(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[885],{

/***/ 35035:
/***/ (function(module) {

"use strict";


module.exports = function (data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = { cmp: opts };
    var cycles = (typeof opts.cycles === 'boolean') ? opts.cycles : false;

    var cmp = opts.cmp && (function (f) {
        return function (node) {
            return function (a, b) {
                var aobj = { key: a, value: node[a] };
                var bobj = { key: b, value: node[b] };
                return f(aobj, bobj);
            };
        };
    })(opts.cmp);

    var seen = [];
    return (function stringify (node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') {
            node = node.toJSON();
        }

        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);

        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for (i = 0; i < node.length; i++) {
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }

        if (node === null) return 'null';

        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }

        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for (i = 0; i < keys.length; i++) {
            var key = keys[i];
            var value = stringify(node[key]);

            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    })(data);
};


/***/ }),

/***/ 79459:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/asigurari-rca",
      function () {
        return __webpack_require__(15572);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 94512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./lib/structuredData.js
var structuredData = __webpack_require__(89229);
;// CONCATENATED MODULE: ./components/BreadcrumbSchema.js




var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, baseUrl = _publicRuntimeConfig.settings.baseUrl;
var BreadcrumbSchema = function(param) {
    var breadcrumbData = param.breadcrumbData, currentPath = param.currentPath;
    // Do not include home page
    // Do not include pages without parent
    if (breadcrumbData && breadcrumbData.length > 1) {
        var itemListElement = breadcrumbData.map(function(breadcrumb, index) {
            return {
                "@type": "ListItem",
                position: index + 1,
                name: breadcrumb.name,
                item: breadcrumb.level != 99 ? "".concat(baseUrl, "/").concat(breadcrumb.url_key).concat(breadcrumb.url_suffix || "") : "".concat(baseUrl).concat(currentPath)
            };
        });
        var schema = {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: itemListElement
        };
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
            type: "application/ld+json",
            dangerouslySetInnerHTML: {
                __html: (0,structuredData/* default */.Z)(schema)
            }
        }));
    }
    return null;
};
/* harmony default export */ var components_BreadcrumbSchema = (BreadcrumbSchema);

;// CONCATENATED MODULE: ./components/Breadcrumbs.js








var Breadcrumbs_ref = (0,config["default"])(), settings = Breadcrumbs_ref.publicRuntimeConfig.settings;
var isBricoStore = settings.websiteName === "bricostore";
var Breadcrumbs = function(param) {
    var breadcrumbs = param.breadcrumbs, _isPDP = param.isPDP, isPDP = _isPDP === void 0 ? false : _isPDP, className = param.className;
    var router = (0,next_router.useRouter)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            breadcrumbs && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BreadcrumbSchema, {
                breadcrumbData: breadcrumbs,
                currentPath: router.asPath
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "Breadcrumbs is-hidden-in-mobile-app pb-3 lg:py-3 truncate text-sm ".concat(className),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                    className: "p-0 m-0 list-none inline",
                    children: breadcrumbs.map(function(breadcrumb, index) {
                        return breadcrumb.level != 99 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            className: classnames_default()("inline", {
                                "text-red-brand": isBricoStore || !isPDP,
                                "text-[#1D4ED8]": !isBricoStore && isPDP
                            }),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "".concat(settings.baseUrl, "/").concat(breadcrumb.url_key).concat(breadcrumb.url_suffix || ""),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        title: breadcrumb.name,
                                        className: classnames_default()({
                                        }),
                                        children: breadcrumb.name
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "mx-1",
                                    children: "/"
                                })
                            ]
                        }, "".concat(breadcrumb.level, "-").concat(breadcrumb.id, "-").concat(index)) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "inline",
                            children: breadcrumb.name
                        }, "".concat(breadcrumb.level, "-").concat(breadcrumb.id, "-").concat(index));
                    })
                })
            })
        ]
    }));
};
Breadcrumbs.propTypes = {
    breadcrumbs: prop_types_default().arrayOf(prop_types_default().shape({
        id: (prop_types_default()).number.isRequired,
        level: (prop_types_default()).number.isRequired,
        name: (prop_types_default()).string.isRequired,
        url_key: function(props, propName) {
            if (props["level"] !== 99 && (typeof props[propName] !== "string" || props[propName].length === 0)) {
                return new Error("Please provide url_key when item level is not 99.");
            }
        },
        url_suffix: (prop_types_default()).string
    })).isRequired
};
/* harmony default export */ var components_Breadcrumbs = (Breadcrumbs);


/***/ }),

/***/ 71662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var InputCheckbox = function(props) {
    var input = props.input, _meta = props.meta, touched = _meta.touched, error = _meta.error, visited = _meta.visited;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                className: "flex ".concat(props.className ? props.className : "", " ").concat(props.disabled ? "disabled" : ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", _objectSpread({}, input, {
                        type: "checkbox",
                        required: props.required,
                        disabled: props.disabled,
                        className: "checkbox-input opacity-0 w-0 h-0 ".concat(touched && error ? "error" : "")
                    })),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "checkbox-control flex-none w-5 h-5 p-1 mr-2 border-gray-light border rounded-4px bg-white ".concat(props.required ? "is-required" : ""),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                            className: "",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 24 24",
                            "aria-hidden": "true",
                            focusable: "false",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "3",
                                d: "M1.73 12.91l6.37 6.37L22.79 4.59"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "block Form-label label ".concat(props.spanClassName, " ").concat(props.required ? "is-required" : ""),
                        children: typeof props.label === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            dangerouslySetInnerHTML: {
                                __html: props.label
                            }
                        }) : props.label
                    })
                ]
            }),
            props.required && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: visited && error ? "" : "hidden",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text-red-brand text-sm",
                    children: error
                })
            })
        ]
    }));
};
InputCheckbox.defaultProps = {
    required: undefined,
    disabled: undefined
};
/* harmony default export */ __webpack_exports__["Z"] = (InputCheckbox);


/***/ }),

/***/ 13890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var InputRadio = function(props) {
    var input = props.input, _meta = props.meta, touched = _meta.touched, error = _meta.error;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
            className: "Form-checkbox flex items-center ".concat(props.className ? props.className : "", " ").concat(props.disabled ? "disabled" : ""),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", _objectSpread({}, input, {
                    id: props.id,
                    type: "radio",
                    disabled: props.disabled,
                    className: "checkbox-input opacity-0 w-0 h-0 ".concat(touched && error ? "error" : "")
                })),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "checkbox-control is-radio flex-none w-5 h-5 p-1 mr-2 border-gray-1600 hover:border-black border rounded-full bg-white ".concat(props.required ? "is-required" : ""),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                        width: "10",
                        height: "10",
                        viewBox: "0 0 10 10",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            width: "10",
                            height: "10",
                            rx: "5",
                            fill: "#319D10"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "inline-block leading-18.2 ".concat(props.labelClass),
                    children: typeof props.label === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        dangerouslySetInnerHTML: {
                            __html: props.label
                        },
                        className: "inline-block"
                    }) : props.label
                })
            ]
        })
    }));
};
InputRadio.defaultProps = {
    disabled: undefined
};
/* harmony default export */ __webpack_exports__["Z"] = (InputRadio);


/***/ }),

/***/ 75860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Rca_LicensePlate; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/Icons/Rca/LicensePlateStars.js

var LicensePlateStars = function(param) {
    var _width = param.width, width = _width === void 0 ? 16 : _width, _height = param.height, height = _height === void 0 ? 16 : _height;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("svg", {
        fill: "none",
        viewBox: "0 0 16 16",
        width: width,
        height: height,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "8",
                cy: "2",
                r: "1",
                fill: "#FFF200"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "4",
                cy: "3.5",
                r: "1",
                fill: "#FFF200"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "2",
                cy: "6",
                r: "1",
                fill: "#FFF200"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "2",
                cy: "10",
                r: "1",
                fill: "#FFF200"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "4",
                cy: "12.5",
                r: "1",
                fill: "#FFF200"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "8",
                cy: "14",
                r: "1",
                fill: "#FFF200"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "12",
                cy: "12.5",
                r: "1",
                fill: "#FFF200"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "14",
                cy: "10",
                r: "1",
                fill: "#FFF200"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "14",
                cy: "6",
                r: "1",
                fill: "#FFF200"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "12",
                cy: "3.5",
                r: "1",
                fill: "#FFF200"
            })
        ]
    });
};
/* harmony default export */ var Rca_LicensePlateStars = (LicensePlateStars);

;// CONCATENATED MODULE: ./components/Rca/LicensePlate.js


var LicensePlate = function(param) {
    var plateNumber = param.plateNumber;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: "flex h-10 w-[184px] items-center rounded-[4px] border-2 border-black",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex h-full w-6 flex-col items-center justify-center gap-[2px] bg-[#034EA2] px-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Rca_LicensePlateStars, {
                        width: 16,
                        height: 16
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-[12px] font-medium leading-[12px] text-[#D9D9D9]",
                        children: "RO"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex h-full flex-1 items-center justify-center bg-white px-2 text-center text-[24px] font-medium uppercase leading-[32px]",
                children: plateNumber
            })
        ]
    });
};
/* harmony default export */ var Rca_LicensePlate = (LicensePlate);


/***/ }),

/***/ 77485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26209);
/* harmony import */ var react_final_form__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66688);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11752);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41664);
/* harmony import */ var _lib_validations__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(38294);
/* harmony import */ var _components_Form_InputText__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(58833);
/* harmony import */ var _components_Button__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52077);
/* harmony import */ var _store_user_actions__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(49865);
/* harmony import */ var _store_app_actions__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(27173);












function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_5__["default"])(), settings = ref.publicRuntimeConfig.settings;
var LoginForm = function(props) {
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), smsData = ref1[0], setSmsData = ref1[1];
    var loginAction = function() {
        var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(values) {
            var res;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return props.userLogin(values, props.redirect || null, true, props.location);
                    case 2:
                        res = _ctx.sent;
                        if (res && !res.token && res.data) {
                            setSmsData(res.data);
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function loginAction(values) {
            return _ref.apply(this, arguments);
        };
    }();
    var postSmsAction = function(values) {
        return props.userLogin({
            sent_code: values.sent_code,
            telephone: smsData.telephone,
            id: smsData.id,
            customer_id: smsData.customer_id
        }, props.redirect || null, true, props.location);
    };
    if (smsData) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_4__/* .Form */ .l0, {
                    onSubmit: postSmsAction,
                    render: function(param) {
                        var handleSubmit = param.handleSubmit, submitting = param.submitting;
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("form", {
                            onSubmit: handleSubmit,
                            className: "text-sm",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "mb-4",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_4__/* .Field */ .gN, {
                                        name: "sent_code",
                                        type: "text",
                                        label: "Cod SMS",
                                        component: _components_Form_InputText__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z,
                                        autoComplete: "one-time-code",
                                        inputClassName: "max-w-fulli",
                                        required: true,
                                        validate: (0,_lib_validations__WEBPACK_IMPORTED_MODULE_7__/* .composeFormValidators */ .JT)((0,_lib_validations__WEBPACK_IMPORTED_MODULE_7__/* .isRequired */ .q9)())
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "mb-4",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Button__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        title: "Verifica",
                                        display: "block",
                                        variant: "primary",
                                        type: "submit",
                                        disabled: submitting
                                    })
                                })
                            ]
                        });
                    }
                }, "ACCOUNT_LOGIN_FORM_SMS"),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "text-center text-sm",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                        className: "text-red-brand hover:text-bleu-hover underline",
                        onClick: function() {
                            setSmsData(null);
                        },
                        children: "Renunta"
                    })
                })
            ]
        }));
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_4__/* .Form */ .l0, {
                onSubmit: loginAction,
                render: function(param) {
                    var handleSubmit = param.handleSubmit, submitting = param.submitting;
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("form", {
                        onSubmit: handleSubmit,
                        className: "text-sm",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "mb-4",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_4__/* .Field */ .gN, {
                                    name: "email",
                                    type: "email",
                                    label: "Introdu adresa de email",
                                    autoComplete: "username",
                                    component: _components_Form_InputText__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z,
                                    inputClassName: "max-w-fulli",
                                    required: true,
                                    placeholder: "Introdu adresa de email",
                                    validate: (0,_lib_validations__WEBPACK_IMPORTED_MODULE_7__/* .composeFormValidators */ .JT)((0,_lib_validations__WEBPACK_IMPORTED_MODULE_7__/* .isRequired */ .q9)(), (0,_lib_validations__WEBPACK_IMPORTED_MODULE_7__/* .isEmail */ .Jh)(), (0,_lib_validations__WEBPACK_IMPORTED_MODULE_7__/* .hasMaxLength */ .aG)(80))
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "mb-6",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_4__/* .Field */ .gN, {
                                    name: "password",
                                    label: "Parola",
                                    type: "password",
                                    autoComplete: "current-password",
                                    component: _components_Form_InputText__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z,
                                    inputClassName: "max-w-fulli",
                                    required: true,
                                    placeholder: "Introdu parola",
                                    validate: (0,_lib_validations__WEBPACK_IMPORTED_MODULE_7__/* .isRequired */ .q9)()
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "mb-4",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Button__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                    title: "Logheaza-te in cont",
                                    display: "block",
                                    variant: "primary",
                                    type: "submit",
                                    disabled: submitting
                                })
                            })
                        ]
                    });
                }
            }, "ACCOUNT_LOGIN_FORM"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "text-center text-sm",
                children: props.recoverPassInModal ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                    className: "text-red-brand hover:text-bleu-hover underline",
                    onClick: function() {
                        props.removeModal();
                        props.addModal(props.resetPassModalId);
                    },
                    children: "Recuperare parola"
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_6__["default"], {
                    href: "".concat(settings.baseUrl, "/cont/parola-uitata/"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                        className: "text-red-brand hover:text-bleu-hover underline",
                        children: "Ai uitat parola?"
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .connect */ .$j)(null, {
    userLogin: _store_user_actions__WEBPACK_IMPORTED_MODULE_10__/* .userLogin */ .n$,
    addModal: _store_app_actions__WEBPACK_IMPORTED_MODULE_11__/* .addModal */ .Y_,
    removeModal: _store_app_actions__WEBPACK_IMPORTED_MODULE_11__/* .removeModal */ .a_
})(LoginForm));


/***/ }),

/***/ 89229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35035);
/* harmony import */ var fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0__);

// JSON-LD blocks are injected with dangerouslySetInnerHTML, so a "<" coming
// from product data (a "</script>" inside a product name or description) would
// close the script element early and make the whole block unparsable for
// crawlers, besides letting the markup run in the browser. These characters
// are only ever part of JSON string values, where the escaped form is
// equivalent, so escaping them keeps the JSON valid and the page safe.
var HTML_UNSAFE_ESCAPES = {
    "<": "\\u003c",
    ">": "\\u003e",
    "&": "\\u0026"
};
var serializeSchema = function(schema) {
    return fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0___default()(schema).replace(/[<>&]/g, function(character) {
        return HTML_UNSAFE_ESCAPES[character];
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (serializeSchema);


/***/ }),

/***/ 15572:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ asigurari_rca; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 10 modules
var es = __webpack_require__(26209);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./components/Breadcrumbs.js + 1 modules
var Breadcrumbs = __webpack_require__(94512);
// EXTERNAL MODULE: ./lib/api/helpers.js
var helpers = __webpack_require__(45963);
// EXTERNAL MODULE: ./lib/api/index.js
var api = __webpack_require__(2642);
// EXTERNAL MODULE: ./node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(66688);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/Form/Radio.js
var Radio = __webpack_require__(13890);
;// CONCATENATED MODULE: ./containers/RCA/RCAProprietar/OwnerTypeSection.js




var OwnerTypeSection = function(param) {
    var values = param.values;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-sm font-medium mb-[10px]",
                children: [
                    "Tip proprietar ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-red-brand",
                        children: "*"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-1 md:grid-cols-2 gap-[16px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("flex items-center p-[16px] bg-white", {
                            "border border-[#99CE88]": (values === null || values === void 0 ? void 0 : values.legalType) === "PF"
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                            name: "legalType",
                            type: "radio",
                            value: "PF",
                            component: Radio/* default */.Z,
                            label: "Persoana fizica",
                            className: classnames_default()("cursor-pointer w-full mb-0", {
                                "pointer-events-none cursor-default": values.legalType === "PF"
                            }),
                            labelClass: "font-normal text-[14px]"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("flex items-center p-[16px] bg-white", {
                            "border border-[#99CE88]": (values === null || values === void 0 ? void 0 : values.legalType) === "PJ"
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                            name: "legalType",
                            type: "radio",
                            value: "PJ",
                            component: Radio/* default */.Z,
                            label: "Persoana juridica",
                            className: classnames_default()("cursor-pointer w-full mb-0", {
                                "pointer-events-none cursor-default": values.legalType === "PJ"
                            }),
                            labelClass: "font-normal text-[14px]"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var RCAProprietar_OwnerTypeSection = (OwnerTypeSection);

// EXTERNAL MODULE: ./lib/validations.js + 1 modules
var validations = __webpack_require__(38294);
// EXTERNAL MODULE: ./components/Form/SelectSearch.js
var SelectSearch = __webpack_require__(9592);
;// CONCATENATED MODULE: ./containers/RCA/RCAProprietar/LeasingSection.js







var LeasingSection = function(param) {
    var isLeasing = param.isLeasing, apiData = param.apiData;
    var ref;
    var leasingCompanies = apiData.leasingCompanies;
    var leasingOptions = (0,react.useMemo)(function() {
        return leasingCompanies && leasingCompanies.map(function(company) {
            return {
                label: company.companyName,
                value: company.cif
            };
        });
    }, [
        leasingCompanies
    ]);
    var ref1;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-sm font-medium mb-[10px]",
                        children: [
                            "Autovehiculul este obiectul unui contract de leasing in desfasurare?",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-red-brand",
                                children: "*"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid grid-cols-1 md:grid-cols-2 gap-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()("flex items-center p-[16px] bg-white", {
                                    "border border-[#99CE88]": !isLeasing
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                    name: "isLeasing",
                                    value: "false",
                                    component: Radio/* default */.Z,
                                    label: "Nu",
                                    type: "radio",
                                    labelClass: "font-normal text-[14px]",
                                    className: classnames_default()("cursor-pointer w-full mb-0", {
                                        "pointer-events-none": !isLeasing
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()("flex items-center p-[16px] bg-white", {
                                    "border border-[#99CE88]": isLeasing
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                    name: "isLeasing",
                                    value: "true",
                                    component: Radio/* default */.Z,
                                    label: "Da",
                                    type: "radio",
                                    labelClass: "font-normal text-[14px]",
                                    className: classnames_default()("cursor-pointer w-full mb-0", {
                                        "pointer-events-none": isLeasing
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            isLeasing && ((ref = apiData.leasingCompanies) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-white p-[16px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    name: "leasingCompanyCif",
                    component: SelectSearch/* default */.Z,
                    label: "Nume companie leasing",
                    required: true,
                    labelClass: "text-sm font-medium",
                    controlClassName: "max-w-fulli",
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)()),
                    placeholder: "alege...",
                    parse: function(option) {
                        return (ref1 = option === null || option === void 0 ? void 0 : option.value) !== null && ref1 !== void 0 ? ref1 : "";
                    },
                    format: function(value) {
                        return leasingOptions.find(function(option) {
                            return String(option.value) === String(value);
                        });
                    },
                    options: leasingOptions || []
                })
            })
        ]
    }));
};
/* harmony default export */ var RCAProprietar_LeasingSection = (LeasingSection);

// EXTERNAL MODULE: ./components/Form/InputText.js + 2 modules
var InputText = __webpack_require__(58833);
// EXTERNAL MODULE: ./components/Form/Select.js
var Select = __webpack_require__(66569);
;// CONCATENATED MODULE: ./containers/RCA/RCAProprietar/CompanyDataSection.js







var INPUT_CLASS = "!max-w-full !min-w-0";
var CompanyDataSection = function(param1) {
    var form = param1.form, apiData = param1.apiData;
    var ref, ref1;
    var caenCodes = apiData.caenCodes, companyTypes = apiData.companyTypes, counties = apiData.counties, cities = apiData.cities;
    var values = form.getState().values;
    var selectedCountyId = values === null || values === void 0 ? void 0 : (ref = values.companyDataSection) === null || ref === void 0 ? void 0 : (ref1 = ref.address) === null || ref1 === void 0 ? void 0 : ref1.countyId;
    var caenCodeOptions = (0,react.useMemo)(function() {
        return caenCodes ? caenCodes.map(function(param) {
            var code = param.code;
            return {
                value: code,
                label: code
            };
        }) : [];
    }, [
        caenCodes
    ]);
    var citiesOptions = (0,react.useMemo)(function() {
        return cities && cities[selectedCountyId] ? cities[selectedCountyId].map(function(param) {
            var id = param.id, name = param.name;
            return {
                value: id,
                label: name
            };
        }) : [];
    }, [
        cities,
        selectedCountyId
    ]);
    var ref2, ref3;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid grid-cols-1 md:grid-cols-2 gap-4 mb-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    name: "companyDataSection.companyName",
                    component: InputText/* default */.Z,
                    label: "Nume companie",
                    required: true,
                    placeholder: "Introdu numele companiei",
                    inputClassName: INPUT_CLASS,
                    labelClass: "text-sm",
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* hasMaxLength */.aG)(100))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    name: "companyDataSection.cif",
                    component: InputText/* default */.Z,
                    label: "CUI/CIF companie",
                    required: true,
                    placeholder: "Introdu CUI/CIF...",
                    inputClassName: INPUT_CLASS,
                    labelClass: "text-sm",
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* hasMaxLength */.aG)(20))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    name: "companyDataSection.caenCode",
                    component: SelectSearch/* default */.Z,
                    label: "Cod CAEN",
                    required: true,
                    placeholder: "alege..",
                    controlClassName: INPUT_CLASS,
                    labelClass: "text-sm",
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)()),
                    parse: function(option) {
                        return (ref2 = option === null || option === void 0 ? void 0 : option.value) !== null && ref2 !== void 0 ? ref2 : "";
                    },
                    format: function(value) {
                        return caenCodeOptions.find(function(option) {
                            return String(option.value) === String(value);
                        });
                    },
                    options: caenCodeOptions
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_final_form_es/* Field */.gN, {
                    name: "companyDataSection.companyTypeId",
                    label: "Tip companie",
                    required: true,
                    inputClassName: INPUT_CLASS,
                    labelClass: "text-sm",
                    component: Select/* default */.Z,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                            value: "",
                            children: "alege..."
                        }),
                        companyTypes && companyTypes.map(function(param) {
                            var type = param.type, id = param.id;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                value: id,
                                children: type
                            }, id);
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    name: "companyDataSection.email",
                    component: InputText/* default */.Z,
                    type: "email",
                    label: "Email companie",
                    required: true,
                    placeholder: "Introdu email companie...",
                    inputClassName: INPUT_CLASS,
                    labelClass: "text-sm",
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* isEmail */.Jh)())
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    name: "companyDataSection.phone",
                    component: InputText/* default */.Z,
                    type: "tel",
                    label: "Telefon companie",
                    required: true,
                    placeholder: "Introdu telefon companie...",
                    inputClassName: INPUT_CLASS,
                    labelClass: "text-sm",
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* isPhoneNumber */.xT)())
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_final_form_es/* Field */.gN, {
                    name: "companyDataSection.address.countyId",
                    label: "Judet companie",
                    required: true,
                    inputClassName: INPUT_CLASS,
                    labelClass: "text-sm",
                    component: Select/* default */.Z,
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)()),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                            value: "",
                            children: "alege..."
                        }),
                        counties && counties.map(function(county) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                value: county.id,
                                children: county.name
                            }, county.id);
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    name: "companyDataSection.address.cityId",
                    component: SelectSearch/* default */.Z,
                    label: "Localitate companie",
                    placeholder: "alege...",
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)()),
                    controlClassName: INPUT_CLASS,
                    labelClass: "text-sm",
                    required: true,
                    options: citiesOptions,
                    parse: function(option) {
                        return (ref3 = option === null || option === void 0 ? void 0 : option.value) !== null && ref3 !== void 0 ? ref3 : "";
                    },
                    format: function(value) {
                        return citiesOptions.find(function(option) {
                            return String(option.value) === String(value);
                        });
                    },
                    disabled: !(cities === null || cities === void 0 ? void 0 : cities[selectedCountyId])
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    name: "companyDataSection.address.streetName",
                    component: InputText/* default */.Z,
                    label: "Adresa companie",
                    required: true,
                    placeholder: "Introdu adresa completa",
                    inputClassName: INPUT_CLASS,
                    labelClass: "text-sm",
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* hasMaxLength */.aG)(100), (0,validations/* isStreetAddress */.PS)())
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    name: "companyDataSection.address.postalCode",
                    component: InputText/* default */.Z,
                    label: "Cod postal companie",
                    placeholder: "Introdu cod postal",
                    inputClassName: INPUT_CLASS,
                    labelClass: "text-sm",
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* hasMaxLength */.aG)(6), (0,validations/* hasMaxLength */.aG)(6))
                })
            })
        ]
    }));
};
/* harmony default export */ var RCAProprietar_CompanyDataSection = (CompanyDataSection);

;// CONCATENATED MODULE: ./containers/RCA/RCAProprietar/OwnerDataSection.js








function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var OwnerDataSection_INPUT_CLASS = "!max-w-full !min-w-0";
var OwnerDataSection = function(param1) {
    var apiData = param1.apiData, form = param1.form;
    var ref, ref1;
    var counties = apiData.counties, cities = apiData.cities;
    var values = form.getState().values;
    var selectedCountyId = values === null || values === void 0 ? void 0 : (ref = values.userDataSection) === null || ref === void 0 ? void 0 : (ref1 = ref.address) === null || ref1 === void 0 ? void 0 : ref1.countyId;
    var countyOptions = (0,react.useMemo)(function() {
        return counties && counties.map(function(param) {
            var id = param.id, name = param.name;
            return {
                value: id,
                label: name
            };
        });
    }, [
        counties
    ]);
    var cityOptions = (0,react.useMemo)(function() {
        return (cities === null || cities === void 0 ? void 0 : cities[selectedCountyId]) ? cities[selectedCountyId].map(function(city) {
            return {
                value: city.id,
                label: city.name
            };
        }) : [];
    }, [
        cities,
        selectedCountyId
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    name: "userDataSection.lastName",
                    component: InputText/* default */.Z,
                    label: "Nume",
                    required: true,
                    placeholder: "Introdu numele complet",
                    inputClassName: OwnerDataSection_INPUT_CLASS,
                    labelClass: "text-sm",
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* isAlphaNumeric */.bJ)(), (0,validations/* hasMaxLength */.aG)(50))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    name: "userDataSection.firstName",
                    component: InputText/* default */.Z,
                    label: "Prenume",
                    required: true,
                    placeholder: "Introdu prenumele complet",
                    inputClassName: OwnerDataSection_INPUT_CLASS,
                    labelClass: "text-sm",
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* isAlphaNumeric */.bJ)(), (0,validations/* hasMaxLength */.aG)(50))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    name: "userDataSection.cif",
                    component: InputText/* default */.Z,
                    label: "CNP",
                    required: true,
                    placeholder: "Introdu CNP",
                    inputClassName: OwnerDataSection_INPUT_CLASS,
                    labelClass: "text-sm",
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* isCNP */.LR)(), (0,validations/* hasMinLength */.vd)(13), (0,validations/* hasMaxLength */.aG)(13))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-2 gap-4 col-span-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                            name: "userDataSection.idSerial",
                            component: InputText/* default */.Z,
                            label: "Serie CI/BI",
                            required: true,
                            placeholder: "AB",
                            inputClassName: OwnerDataSection_INPUT_CLASS,
                            labelClass: "text-sm",
                            format: function(value) {
                                return value === null || value === void 0 ? void 0 : value.toUpperCase();
                            },
                            validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* hasMaxLength */.aG)(2), (0,validations/* hasMinLength */.vd)(2))
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                            name: "userDataSection.idNumber",
                            component: InputText/* default */.Z,
                            label: "Numar CI/BI",
                            required: true,
                            placeholder: "123456",
                            inputClassName: OwnerDataSection_INPUT_CLASS,
                            labelClass: "text-sm",
                            validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* hasMinLength */.vd)(6), (0,validations/* hasMaxLength */.aG)(7))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    name: "userDataSection.address.countyId",
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)()),
                    children: function(param2) {
                        var input = param2.input, meta = param2.meta;
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Select/* default */.Z, {
                            input: _objectSpread({}, input, {
                                value: input.value || "",
                                onChange: function() {
                                    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(e) {
                                        var countyId;
                                        return runtime_default().wrap(function _callee$(_ctx) {
                                            while(1)switch(_ctx.prev = _ctx.next){
                                                case 0:
                                                    countyId = e.target.value;
                                                    input.onChange(countyId);
                                                    form.change("userDataSection.address.cityId", null);
                                                case 3:
                                                case "end":
                                                    return _ctx.stop();
                                            }
                                        }, _callee);
                                    }));
                                    return function(e) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()
                            }),
                            meta: meta,
                            label: "Judet",
                            required: true,
                            inputClassName: OwnerDataSection_INPUT_CLASS,
                            labelClass: "text-sm",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "",
                                    children: "alege..."
                                }),
                                counties && countyOptions.map(function(param) {
                                    var value = param.value, label = param.label;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                        value: value,
                                        children: label
                                    }, value);
                                })
                            ]
                        });
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    name: "userDataSection.address.cityId",
                    component: SelectSearch/* default */.Z,
                    label: "Localitate",
                    required: true,
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)()),
                    controlClassName: OwnerDataSection_INPUT_CLASS,
                    labelClass: "text-sm",
                    placeholder: "Cauta localitatea",
                    disabled: !(cities === null || cities === void 0 ? void 0 : cities[selectedCountyId]),
                    parse: function(option) {
                        return option.value;
                    },
                    format: function(value) {
                        return cityOptions.find(function(option) {
                            return String(option.value) === String(value);
                        }) || null;
                    },
                    options: cityOptions || []
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    name: "userDataSection.address.streetName",
                    component: InputText/* default */.Z,
                    label: "Adresa",
                    required: true,
                    placeholder: "Introdu adresa completa",
                    inputClassName: OwnerDataSection_INPUT_CLASS,
                    labelClass: "text-sm",
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* hasMaxLength */.aG)(300))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    name: "userDataSection.address.postalCode",
                    component: InputText/* default */.Z,
                    label: "Cod postal",
                    placeholder: "Introdu cod postal",
                    inputClassName: OwnerDataSection_INPUT_CLASS,
                    labelClass: "text-sm",
                    required: true,
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* hasMaxLength */.aG)(6), (0,validations/* hasMinLength */.vd)(6))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    name: "userDataSection.email",
                    component: InputText/* default */.Z,
                    type: "email",
                    label: "Email",
                    required: true,
                    placeholder: "Introdu email",
                    inputClassName: OwnerDataSection_INPUT_CLASS,
                    labelClass: "text-sm",
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* isEmail */.Jh)())
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    name: "userDataSection.phone",
                    component: InputText/* default */.Z,
                    type: "tel",
                    label: "Telefon",
                    required: true,
                    placeholder: "Introdu telefon",
                    inputClassName: OwnerDataSection_INPUT_CLASS,
                    labelClass: "text-sm",
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* isPhoneNumber */.xT)())
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    name: "userDataSection.idExpirationDate",
                    component: InputText/* default */.Z,
                    type: "number",
                    label: "An expirare CI/BI",
                    required: true,
                    placeholder: new Date().getFullYear().toString(),
                    inputClassName: OwnerDataSection_INPUT_CLASS,
                    labelClass: "text-sm",
                    parse: function(value) {
                        return (value === null || value === void 0 ? void 0 : value.includes("-")) ? new Date(value).getFullYear().toString() : value;
                    },
                    format: function(value) {
                        return (value === null || value === void 0 ? void 0 : value.includes("-")) ? new Date(value).getFullYear().toString() : value;
                    },
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* hasMinVal */.Lg)(new Date().getFullYear()), (0,validations/* hasMaxLength */.aG)(4), (0,validations/* hasMinLength */.vd)(4))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    name: "userDataSection.driverLicenceDate",
                    component: InputText/* default */.Z,
                    placeholder: new Date().getFullYear().toString(),
                    label: "An obtinere permis",
                    type: "number",
                    required: true,
                    inputClassName: OwnerDataSection_INPUT_CLASS,
                    labelClass: "text-sm",
                    parse: function(value) {
                        return (value === null || value === void 0 ? void 0 : value.includes("-")) ? new Date(value).getFullYear().toString() : value;
                    },
                    format: function(value) {
                        return (value === null || value === void 0 ? void 0 : value.includes("-")) ? new Date(value).getFullYear().toString() : value;
                    },
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* hasMaxVal */.jT)(new Date().getFullYear()), (0,validations/* hasMaxLength */.aG)(4), (0,validations/* hasMinLength */.vd)(4))
                })
            })
        ]
    }));
};
/* harmony default export */ var RCAProprietar_OwnerDataSection = (OwnerDataSection);

;// CONCATENATED MODULE: ./containers/RCA/RCAProprietar/MainDriverSection.js






var MainDriverSection_INPUT_CLASS = "!max-w-full !min-w-0";
var MainDriverSection = function(param) {
    var values = param.values, isCompany = param.isCompany;
    var ref, ref1, ref2, ref3, ref4;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-[14px] mb-3 font-medium",
                        children: [
                            "Conducatorul principal al vehiculului",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-red-brand",
                                children: "*"
                            })
                        ]
                    }),
                    !isCompany && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid grid-cols-1 md:grid-cols-2 gap-[16px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()("flex items-center p-[16px] bg-white", {
                                    "border border-[#99CE88]": ((ref = values.mainDriverSection) === null || ref === void 0 ? void 0 : ref.mainDriver) === "owner"
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                    name: "mainDriverSection.mainDriver",
                                    type: "radio",
                                    value: "owner",
                                    component: Radio/* default */.Z,
                                    label: "Acelasi cu proprietarul",
                                    className: classnames_default()("cursor-pointer w-full mb-0", {
                                        "pointer-events-none cursor-default": ((ref1 = values.mainDriverSection) === null || ref1 === void 0 ? void 0 : ref1.mainDriver) === "owner"
                                    }),
                                    labelClass: "font-normal text-[14px]"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()("flex items-center p-[16px] bg-white", {
                                    "border border-[#99CE88]": ((ref2 = values.mainDriverSection) === null || ref2 === void 0 ? void 0 : ref2.mainDriver) === "other"
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                    name: "mainDriverSection.mainDriver",
                                    type: "radio",
                                    value: "other",
                                    component: Radio/* default */.Z,
                                    label: "Altul",
                                    className: classnames_default()("cursor-pointer w-full mb-0", {
                                        "pointer-events-none cursor-default": ((ref3 = values.mainDriverSection) === null || ref3 === void 0 ? void 0 : ref3.mainDriver) === "other"
                                    }),
                                    labelClass: "font-normal text-[14px]"
                                })
                            })
                        ]
                    })
                ]
            }),
            (((ref4 = values.mainDriverSection) === null || ref4 === void 0 ? void 0 : ref4.mainDriver) === "other" || isCompany) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-6 grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4 bg-white p-[16px] ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                            name: "mainDriverSection.mainDriverData.lastName",
                            component: InputText/* default */.Z,
                            label: "Nume",
                            required: true,
                            placeholder: "Introdu numele complet",
                            inputClassName: MainDriverSection_INPUT_CLASS,
                            labelClass: "text-sm",
                            validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* isAlphaNumeric */.bJ)(), (0,validations/* hasMaxLength */.aG)(50))
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                            name: "mainDriverSection.mainDriverData.firstName",
                            component: InputText/* default */.Z,
                            label: "Prenume",
                            required: true,
                            placeholder: "Introdu prenumele complet",
                            inputClassName: MainDriverSection_INPUT_CLASS,
                            labelClass: "text-sm",
                            validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* isAlphaNumeric */.bJ)(), (0,validations/* hasMaxLength */.aG)(50))
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                            name: "mainDriverSection.mainDriverData.cif",
                            component: InputText/* default */.Z,
                            label: "CNP",
                            required: true,
                            placeholder: "Introdu CNP",
                            inputClassName: MainDriverSection_INPUT_CLASS,
                            labelClass: "text-sm",
                            validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* isCNP */.LR)(), (0,validations/* hasMinLength */.vd)(13), (0,validations/* hasMaxLength */.aG)(13))
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                            name: "mainDriverSection.mainDriverData.email",
                            component: InputText/* default */.Z,
                            type: "email",
                            label: "Email",
                            required: true,
                            placeholder: "Introdu email",
                            inputClassName: MainDriverSection_INPUT_CLASS,
                            labelClass: "text-sm",
                            validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* isEmail */.Jh)())
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                            name: "mainDriverSection.mainDriverData.phone",
                            component: InputText/* default */.Z,
                            type: "tel",
                            label: "Telefon",
                            required: true,
                            placeholder: "Introdu telefon",
                            inputClassName: MainDriverSection_INPUT_CLASS,
                            labelClass: "text-sm",
                            validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* isPhoneNumber */.xT)())
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                            name: "mainDriverSection.mainDriverData.idExpirationDate",
                            component: InputText/* default */.Z,
                            type: "number",
                            label: "An expirare CI/BI",
                            required: true,
                            placeholder: new Date().getFullYear().toString(),
                            inputClassName: MainDriverSection_INPUT_CLASS,
                            labelClass: "text-sm",
                            parse: function(value) {
                                return (value === null || value === void 0 ? void 0 : value.includes("-")) ? new Date(value).getFullYear().toString() : value;
                            },
                            format: function(value) {
                                return (value === null || value === void 0 ? void 0 : value.includes("-")) ? new Date(value).getFullYear().toString() : value;
                            },
                            validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* hasMinVal */.Lg)(new Date().getFullYear()), (0,validations/* hasMaxLength */.aG)(4), (0,validations/* hasMinLength */.vd)(4))
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                            name: "mainDriverSection.mainDriverData.driverLicenceDate",
                            component: InputText/* default */.Z,
                            placeholder: new Date().getFullYear().toString(),
                            label: "An obtinere permis",
                            type: "number",
                            required: true,
                            inputClassName: MainDriverSection_INPUT_CLASS,
                            labelClass: "text-sm",
                            parse: function(value) {
                                return (value === null || value === void 0 ? void 0 : value.includes("-")) ? new Date(value).getFullYear().toString() : value;
                            },
                            format: function(value) {
                                return (value === null || value === void 0 ? void 0 : value.includes("-")) ? new Date(value).getFullYear().toString() : value;
                            },
                            validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* hasMaxVal */.jT)(new Date().getFullYear()), (0,validations/* hasMaxLength */.aG)(4), (0,validations/* hasMinLength */.vd)(4))
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid grid-cols-2 gap-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                    name: "mainDriverSection.mainDriverData.idSerial",
                                    component: InputText/* default */.Z,
                                    label: "Serie CI/BI",
                                    required: true,
                                    placeholder: "Introdu seria",
                                    inputClassName: MainDriverSection_INPUT_CLASS,
                                    labelClass: "text-sm",
                                    format: function(value) {
                                        return value === null || value === void 0 ? void 0 : value.toUpperCase();
                                    },
                                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* hasMinLength */.vd)(2), (0,validations/* hasMaxLength */.aG)(2))
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                    name: "mainDriverSection.mainDriverData.idNumber",
                                    component: InputText/* default */.Z,
                                    label: "Numar CI/BI",
                                    required: true,
                                    placeholder: "123456",
                                    inputClassName: MainDriverSection_INPUT_CLASS,
                                    labelClass: "text-sm",
                                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* hasMinLength */.vd)(6), (0,validations/* hasMaxLength */.aG)(7))
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var RCAProprietar_MainDriverSection = (MainDriverSection);

// EXTERNAL MODULE: ./components/Form/Checkbox.js
var Checkbox = __webpack_require__(71662);
;// CONCATENATED MODULE: ./containers/RCA/RCAProprietar/GdprConsentSection.js





var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, baseUrl = _publicRuntimeConfig.settings.baseUrl;
var GdprConsentSection = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
        className: "space-y-[20px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bg-white p-[16px] space-y-[16px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    name: "policyConsultancy",
                    component: Checkbox/* default */.Z,
                    type: "checkbox",
                    label: "Declar ca aleg sa renunt la acordarea consultantei, in conformitate cu prevederile legale aplicabile comercializarii electronice a produselor de asigurare.",
                    required: true,
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)()),
                    className: "text-[14px] font-normal cursor-pointer max-w-fit"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    name: "policyTermsAndPrivacy",
                    component: Checkbox/* default */.Z,
                    type: "checkbox",
                    label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "Accept",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "".concat(baseUrl, "/rca-termeni-conditii/pag/"),
                                className: "font-medium text-red-brand hover:text-bleu-hover underline",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: "Termenii și Conditiile,"
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "".concat(baseUrl, "/rca-protectia-datelor-caracter-personal/pag/"),
                                className: "font-medium text-red-brand hover:text-bleu-hover underline",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: "Politica de confidentialitate si consimtamantul GDPR"
                            }),
                            " ",
                            "si sunt de acord cu prelucrarea datelor personale in scopul procesarii acestei solicitari."
                        ]
                    }),
                    required: true,
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)()),
                    className: "text-[14px] font-normal cursor-pointer max-w-fit"
                })
            ]
        })
    });
};
/* harmony default export */ var RCAProprietar_GdprConsentSection = (GdprConsentSection);

// EXTERNAL MODULE: ./components/Heading.js
var Heading = __webpack_require__(73510);
// EXTERNAL MODULE: ./components/Button.js
var Button = __webpack_require__(52077);
;// CONCATENATED MODULE: ./containers/RCA/rcaHelpers.js
function rcaHelpers_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function rcaHelpers_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            rcaHelpers_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var buildPFVehicleOwner = function(data) {
    var _address = data.address, countyId = _address.countyId, cityId = _address.cityId, driverLicenceDate = data.driverLicenceDate, idExpirationDate = data.idExpirationDate, restAddress = _objectWithoutProperties(data.address, [
        "countyId",
        "cityId"
    ]), restData = _objectWithoutProperties(data, [
        "address",
        "driverLicenceDate",
        "idExpirationDate"
    ]);
    return rcaHelpers_objectSpread({}, restData, {
        address: rcaHelpers_objectSpread({}, restAddress, {
            addressType: "HOME",
            countryId: 185,
            countyId: Number(countyId),
            cityId: Number(cityId),
            foreignCountyName: "",
            foreignCityName: "",
            streetTypeId: 41
        }),
        legalType: "PF",
        idType: "CI",
        idExpirationDate: "".concat(idExpirationDate, "-01-01T00:00:00"),
        driverLicenceDate: "".concat(driverLicenceDate, "-01-01T00:00:00")
    });
};
var buildPJVehicleOwner = function(data) {
    var address = data.address, restData = _objectWithoutProperties(data, [
        "address"
    ]);
    return rcaHelpers_objectSpread({
        legalType: "PJ"
    }, restData, {
        companyTypeId: Number(restData.companyTypeId),
        address: rcaHelpers_objectSpread({}, address, {
            addressType: "HOME",
            countryId: 185,
            countyId: Number(address.countyId),
            cityId: Number(address.cityId),
            streetTypeId: 41
        })
    });
};

var buildVehicleDriverPayload = function(param) {
    var formValues = param.formValues;
    var legalType = formValues.legalType, _mainDriverSection = formValues.mainDriverSection, mainDriver = _mainDriverSection.mainDriver, mainDriverData = _mainDriverSection.mainDriverData, _userDataSection = formValues.userDataSection, address = _userDataSection.address, idExpirationDate = _userDataSection.idExpirationDate, driverLicenceDate = _userDataSection.driverLicenceDate, restUserDataSection = _objectWithoutProperties(formValues.userDataSection, [
        "address",
        "idExpirationDate",
        "driverLicenceDate"
    ]);
    if (legalType === "PF" && mainDriver === "owner") {
        return rcaHelpers_objectSpread({}, restUserDataSection, {
            legalType: "PF",
            idType: "CI",
            idExpirationDate: "".concat(idExpirationDate, "-01-01T00:00:00"),
            driverLicenceDate: "".concat(driverLicenceDate, "-01-01T00:00:00")
        });
    }
    if (legalType === "PF" && mainDriver === "other" || legalType === "PJ") {
        return rcaHelpers_objectSpread({}, mainDriverData, {
            legalType: "PF",
            idType: "CI",
            idExpirationDate: "".concat(mainDriverData.idExpirationDate, "-01-01T00:00:00"),
            driverLicenceDate: "".concat(mainDriverData.driverLicenceDate, "-01-01T00:00:00")
        });
    }
};
var buildVehicleUserPayload = function(param) {
    var formValues = param.formValues;
    var legalType = formValues.legalType, _companyDataSection = formValues.companyDataSection, companyTypeId = _companyDataSection.companyTypeId, companyAddress = _companyDataSection.address, _userDataSection = formValues.userDataSection, userAddress = _userDataSection.address, restCompanyDataSection = _objectWithoutProperties(formValues.companyDataSection, [
        "companyTypeId",
        "address"
    ]), restUserDataSection = _objectWithoutProperties(formValues.userDataSection, [
        "address"
    ]);
    if (legalType === "PF") {
        return rcaHelpers_objectSpread({}, restUserDataSection, {
            legalType: "PF",
            idType: "CI",
            idExpirationDate: "".concat(restUserDataSection.idExpirationDate, "-01-01T00:00:00"),
            driverLicenceDate: "".concat(restUserDataSection.driverLicenceDate, "-01-01T00:00:00"),
            address: rcaHelpers_objectSpread({}, userAddress, {
                addressType: "HOME",
                countryId: 185,
                countyId: Number(userAddress.countyId),
                cityId: Number(userAddress.cityId),
                foreignCountyName: "",
                foreignCityName: "",
                streetTypeId: 41
            })
        });
    }
    if (legalType === "PJ") {
        return rcaHelpers_objectSpread({}, restCompanyDataSection, {
            legalType: "PJ",
            companyTypeId: Number(companyTypeId),
            address: rcaHelpers_objectSpread({}, companyAddress, {
                addressType: "HOME",
                countryId: 185,
                countyId: Number(companyAddress.countyId),
                cityId: Number(companyAddress.cityId),
                foreignCountyName: "",
                foreignCityName: "",
                streetTypeId: 41
            })
        });
    }
};
var buildVehicleOwnerPayload = function(param) {
    var formValues = param.formValues, leasingCompany = param.leasingCompany;
    if (formValues.isLeasing === "true" && leasingCompany) {
        return buildLeasingOwner(leasingCompany);
    }
    return formValues.legalType === "PF" ? buildPFVehicleOwner(formValues.userDataSection) : buildPJVehicleOwner(formValues.companyDataSection);
};
var buildOwnerSectionPayload = function(param) {
    var formValues = param.formValues, leasingCompany = param.leasingCompany;
    return {
        vehicleOwner: buildVehicleOwnerPayload({
            formValues: formValues,
            leasingCompany: leasingCompany
        }),
        vehicleUser: buildVehicleUserPayload({
            formValues: formValues
        }),
        vehicleDriver: buildVehicleDriverPayload({
            formValues: formValues
        })
    };
};
var buildLeasingOwner = function(leasingCompany) {
    var legalType = leasingCompany.legalType, companyName = leasingCompany.companyName, caenCode = leasingCompany.caenCode, companyTypeId = leasingCompany.companyTypeId, email = leasingCompany.email, phoneNumber = leasingCompany.phoneNumber, cif = leasingCompany.cif, countryId = leasingCompany.countryId, cityId = leasingCompany.cityId, countyId = leasingCompany.countyId, postalCode = leasingCompany.postalCode, streetTypeId = leasingCompany.streetTypeId, addressType = leasingCompany.addressType, foreignCountyName = leasingCompany.foreignCountyName, foreignCityName = leasingCompany.foreignCityName, streetName = leasingCompany.streetName;
    return {
        legalType: legalType,
        companyName: companyName,
        caenCode: caenCode,
        companyTypeId: companyTypeId,
        email: email,
        phone: phoneNumber,
        cif: cif,
        address: {
            addressType: addressType || "HOME",
            countryId: countryId || 185,
            countyId: countyId,
            cityId: cityId,
            streetName: streetName,
            postalCode: postalCode,
            foreignCountyName: foreignCountyName,
            foreignCityName: foreignCityName,
            streetTypeId: streetTypeId
        }
    };
};
var getYearFromDateString = function(dateString) {
    if (!dateString) return "";
    var date = new Date(dateString);
    if (isNaN(date.getFullYear())) {
        return "";
    }
    return date.getFullYear().toString();
};

// EXTERNAL MODULE: ./store/app/actions.js
var actions = __webpack_require__(27173);
;// CONCATENATED MODULE: ./containers/RCA/RCAProprietar/index.js

















function RCAProprietar_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function RCAProprietar_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                RCAProprietar_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                RCAProprietar_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function RCAProprietar_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function RCAProprietar_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            RCAProprietar_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var RCAProprietar = function(param1) {
    var onApiDataUpdate = param1.onApiDataUpdate, apiData = param1.apiData, onStepChange = param1.onStepChange, onFormDataUpdate = param1.onFormDataUpdate, onLoadingStateChange = param1.onLoadingStateChange, formData = param1.formData, isFetching = param1.isFetching, addAlert1 = param1.addAlert, onErrorsUpdate = param1.onErrorsUpdate;
    var counties = apiData.counties, leasingCompanies = apiData.leasingCompanies, cities = apiData.cities, companyTypes = apiData.companyTypes, caenCodes = apiData.caenCodes, selectedVehicle = apiData.selectedVehicle, savedVehicles = apiData.savedVehicles;
    var hasCompanyData = (companyTypes === null || companyTypes === void 0 ? void 0 : companyTypes.length) > 0 && (caenCodes === null || caenCodes === void 0 ? void 0 : caenCodes.length) > 0;
    (0,react.useEffect)(function() {
        if (!counties) {
            getFormData({
                type: "countiesData"
            });
        }
    }, []);
    var fetchCounties = (0,react.useCallback)(RCAProprietar_asyncToGenerator(runtime_default().mark(function _callee() {
        var response1;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(counties === null || counties === void 0 ? void 0 : counties.length)) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 2:
                    _ctx.next = 4;
                    return (0,helpers/* makeApiCall */.Vo)({
                        apiCall: api/* getCountiesRCAApi */.ivb,
                        returnResponse: true,
                        formatResponse: function(response) {
                            var formatedCounties = response.data.data.items.map(function(county) {
                                return county.name === "Bucuresti" ? RCAProprietar_objectSpread({}, county, {
                                    name: "Bucuresti ".concat(county.code.replace("B", "S"))
                                }) : county;
                            }).sort(function(a, b) {
                                return a.name.localeCompare(b.name);
                            });
                            return formatedCounties;
                        },
                        preFail: function() {
                            addAlert1({
                                message: "Eroare la incarcarea judetelor.",
                                variant: "error"
                            });
                            onErrorsUpdate({
                                message: "Eroare la incarcarea judetelor.",
                                variant: "error"
                            });
                        }
                    });
                case 4:
                    response1 = _ctx.sent;
                    if (response1 === null || response1 === void 0 ? void 0 : response1.length) {
                        onApiDataUpdate({
                            counties: response1
                        });
                    }
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), []);
    var fetchLeasingCompanies = (0,react.useCallback)(RCAProprietar_asyncToGenerator(runtime_default().mark(function _callee() {
        var ref, response2;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    if (!(leasingCompanies === null || leasingCompanies === void 0 ? void 0 : leasingCompanies.length)) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 3:
                    _ctx.next = 5;
                    return (0,helpers/* makeApiCall */.Vo)({
                        apiCall: api/* getCompaniesLeasingApi */.lAj,
                        returnResponse: true,
                        formatResponse: function(response) {
                            return response.data.data;
                        },
                        preFail: function() {
                            addAlert1({
                                message: "Eroare la incarcarea companiilor de leasing.",
                                variant: "error"
                            });
                            onErrorsUpdate({
                                message: "Eroare la incarcarea companiilor de leasing.",
                                variant: "error"
                            });
                        }
                    });
                case 5:
                    response2 = _ctx.sent;
                    if ((ref = response2.items) === null || ref === void 0 ? void 0 : ref.length) {
                        onApiDataUpdate({
                            leasingCompanies: response2.items
                        });
                    }
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), []);
    var fetchCitiesInRegion = function() {
        var _ref = RCAProprietar_asyncToGenerator(runtime_default().mark(function _callee(countyId) {
            var ref, ref1, response3;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!(cities === null || cities === void 0 ? void 0 : (ref = cities[countyId]) === null || ref === void 0 ? void 0 : ref.length)) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        _ctx.next = 5;
                        return (0,helpers/* makeApiCall */.Vo)({
                            apiCall: api/* getCitiesRCAApi */.N0Z,
                            apiArgs: [
                                countyId
                            ],
                            formatResponse: function(response) {
                                return response.data.data;
                            },
                            preFail: function() {
                                addAlert1({
                                    message: "Eroare la incarcarea localitatilor.",
                                    variant: "error"
                                });
                                onErrorsUpdate({
                                    message: "Eroare la incarcarea localitatilor.",
                                    variant: "error"
                                });
                            }
                        });
                    case 5:
                        response3 = _ctx.sent;
                        if (response3 === null || response3 === void 0 ? void 0 : (ref1 = response3.items) === null || ref1 === void 0 ? void 0 : ref1.length) {
                            onApiDataUpdate({
                                cities: RCAProprietar_objectSpread({}, cities, RCAProprietar_defineProperty({}, countyId, response3.items))
                            });
                        }
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchCitiesInRegion(countyId) {
            return _ref.apply(this, arguments);
        };
    }();
    var fetchCompanyTypes = (0,react.useCallback)(RCAProprietar_asyncToGenerator(runtime_default().mark(function _callee() {
        var ref, response4;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    if (!(companyTypes === null || companyTypes === void 0 ? void 0 : companyTypes.length)) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 3:
                    _ctx.next = 5;
                    return (0,helpers/* makeApiCall */.Vo)({
                        apiCall: api/* getCompanyTypesApi */.OD0,
                        returnResponse: true,
                        formatResponse: function(response) {
                            return response.data.data;
                        },
                        preFail: function() {
                            addAlert1({
                                message: "Eroare la incarcarea tipurilor de companii.",
                                variant: "error"
                            });
                            onErrorsUpdate({
                                message: "Eroare la incarcarea tipurilor de companii.",
                                variant: "error"
                            });
                        }
                    });
                case 5:
                    response4 = _ctx.sent;
                    if (response4 === null || response4 === void 0 ? void 0 : (ref = response4.items) === null || ref === void 0 ? void 0 : ref.length) {
                        onApiDataUpdate({
                            companyTypes: response4.items
                        });
                    }
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), []);
    var fetchCaenCodes = (0,react.useCallback)(RCAProprietar_asyncToGenerator(runtime_default().mark(function _callee() {
        var ref, response5;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    if (!(caenCodes === null || caenCodes === void 0 ? void 0 : caenCodes.length)) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 3:
                    _ctx.next = 5;
                    return (0,helpers/* makeApiCall */.Vo)({
                        apiCall: api/* getCompanyCaenCodesApi */.nxF,
                        returnResponse: true,
                        formatResponse: function(response) {
                            return response.data.data;
                        },
                        preFail: function() {
                            addAlert1({
                                message: "Eroare la incarcarea codurilor CAEN.",
                                variant: "error"
                            });
                            onErrorsUpdate({
                                message: "Eroare la incarcarea codurilor CAEN.",
                                variant: "error"
                            });
                        }
                    });
                case 5:
                    response5 = _ctx.sent;
                    if (response5 === null || response5 === void 0 ? void 0 : (ref = response5.items) === null || ref === void 0 ? void 0 : ref.length) {
                        onApiDataUpdate({
                            caenCodes: response5.items
                        });
                    }
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), []);
    var getFormData = function() {
        var _ref = RCAProprietar_asyncToGenerator(runtime_default().mark(function _callee(param) {
            var type, payload;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        type = param.type, payload = param.payload;
                        onLoadingStateChange(true);
                        _ctx.t0 = type;
                        _ctx.next = _ctx.t0 === "companyData" ? 5 : _ctx.t0 === "leasingData" ? 8 : _ctx.t0 === "citiesInRegionData" ? 11 : _ctx.t0 === "countiesData" ? 14 : 17;
                        break;
                    case 5:
                        _ctx.next = 7;
                        return Promise.all([
                            fetchCompanyTypes(),
                            fetchCaenCodes()
                        ]);
                    case 7:
                        return _ctx.abrupt("break", 18);
                    case 8:
                        _ctx.next = 10;
                        return fetchLeasingCompanies();
                    case 10:
                        return _ctx.abrupt("break", 18);
                    case 11:
                        _ctx.next = 13;
                        return fetchCitiesInRegion(payload);
                    case 13:
                        return _ctx.abrupt("break", 18);
                    case 14:
                        _ctx.next = 16;
                        return fetchCounties();
                    case 16:
                        return _ctx.abrupt("break", 18);
                    case 17:
                        return _ctx.abrupt("break", 18);
                    case 18:
                        onLoadingStateChange(false);
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getFormData(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleFormValuesChange = function(param) {
        var values = param.values, form = param.form;
        var ref, ref2, ref3, ref4, ref5;
        if (JSON.stringify(values) !== JSON.stringify(formData.proprietarForm)) {
            onFormDataUpdate({
                proprietarForm: values
            });
        }
        var isLeasing = values.isLeasing === "true";
        var isCompany = values.legalType === "PJ";
        var countyId = isCompany ? (ref = values.companyDataSection) === null || ref === void 0 ? void 0 : (ref2 = ref.address) === null || ref2 === void 0 ? void 0 : ref2.countyId : (ref3 = values.userDataSection) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.address) === null || ref4 === void 0 ? void 0 : ref4.countyId;
        // Fetch necessary data based on form values
        if (isCompany && !hasCompanyData && !isFetching) {
            getFormData({
                type: "companyData"
            });
        }
        if (isLeasing && !leasingCompanies && !isFetching) {
            getFormData({
                type: "leasingData"
            });
        }
        if (countyId && !(cities === null || cities === void 0 ? void 0 : (ref5 = cities[countyId]) === null || ref5 === void 0 ? void 0 : ref5.length) && !isFetching) {
            getFormData({
                type: "citiesInRegionData",
                payload: countyId
            });
        }
        if (!isLeasing && values.leasingCompanyCif) {
            form.change("leasingCompanyCif", "");
        }
    };
    var onSubmit = function(formValues) {
        var isLeasing = formValues.isLeasing, leasingCompanyCif = formValues.leasingCompanyCif;
        var leasingCompany;
        if (isLeasing === "true" && leasingCompanyCif) {
            leasingCompany = leasingCompanies.find(function(company) {
                return company.cif === leasingCompanyCif;
            });
        }
        var ownerPayload = buildOwnerSectionPayload({
            formValues: formValues,
            leasingCompany: leasingCompany
        });
        var payload = RCAProprietar_objectSpread({}, formData, {
            vehicle: RCAProprietar_objectSpread({}, formData.vehicle, ownerPayload, {
                isLeasing: isLeasing === "true"
            })
        });
        onFormDataUpdate(payload);
        onStepChange(3);
    };
    var initialValues = (0,react.useMemo)(function() {
        var ref, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
        if (formData.proprietarForm) {
            return formData.proprietarForm;
        }
        var vehicle = RCAProprietar_objectSpread({}, savedVehicles === null || savedVehicles === void 0 ? void 0 : savedVehicles[selectedVehicle]);
        // some address ids need to be removed from the payload
        if (((ref = vehicle.vehicleOwner) === null || ref === void 0 ? void 0 : ref.address) || ((ref6 = vehicle.vehicleUser) === null || ref6 === void 0 ? void 0 : ref6.address) || ((ref7 = vehicle.vehicleDriver) === null || ref7 === void 0 ? void 0 : ref7.address)) {
            var ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29;
            (ref18 = vehicle.vehicleOwner) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.address) === null || ref19 === void 0 ? void 0 : delete ref19.id;
            (ref20 = vehicle.vehicleOwner) === null || ref20 === void 0 ? void 0 : delete ref20.addressId;
            (ref21 = vehicle.vehicleOwner) === null || ref21 === void 0 ? void 0 : delete ref21.id;
            (ref22 = vehicle.vehicleUser) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.address) === null || ref23 === void 0 ? void 0 : delete ref23.id;
            (ref24 = vehicle.vehicleUser) === null || ref24 === void 0 ? void 0 : delete ref24.addressId;
            (ref25 = vehicle.vehicleUser) === null || ref25 === void 0 ? void 0 : delete ref25.id;
            (ref26 = vehicle.vehicleDriver) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.address) === null || ref27 === void 0 ? void 0 : delete ref27.id;
            (ref28 = vehicle.vehicleDriver) === null || ref28 === void 0 ? void 0 : delete ref28.addressId;
            (ref29 = vehicle.vehicleDriver) === null || ref29 === void 0 ? void 0 : delete ref29.id;
        }
        var ownerLegalType = vehicle.isLeasing ? (ref8 = vehicle.vehicleUser) === null || ref8 === void 0 ? void 0 : ref8.legalType : (ref9 = vehicle.vehicleOwner) === null || ref9 === void 0 ? void 0 : ref9.legalType;
        return Object.keys(vehicle).length ? RCAProprietar_objectSpread({
            // legalType block scoped to know which data to use in form payload
            legalType: ownerLegalType || "PF",
            userDataSection: vehicle.isLeasing ? RCAProprietar_objectSpread({}, vehicle.vehicleUser, {
                idExpirationDate: getYearFromDateString((ref10 = vehicle.vehicleUser) === null || ref10 === void 0 ? void 0 : ref10.idExpirationDate),
                driverLicenceDate: getYearFromDateString((ref11 = vehicle.vehicleUser) === null || ref11 === void 0 ? void 0 : ref11.driverLicenceDate)
            }) : ownerLegalType === "PJ" ? {} : RCAProprietar_objectSpread({}, vehicle.vehicleOwner, {
                idExpirationDate: getYearFromDateString((ref12 = vehicle.vehicleOwner) === null || ref12 === void 0 ? void 0 : ref12.idExpirationDate),
                driverLicenceDate: getYearFromDateString((ref13 = vehicle.vehicleOwner) === null || ref13 === void 0 ? void 0 : ref13.driverLicenceDate)
            }),
            companyDataSection: vehicle.isLeasing ? vehicle.vehicleUser : ownerLegalType === "PJ" ? RCAProprietar_objectSpread({}, vehicle.vehicleOwner) : {},
            mainDriverSection: {
                mainDriver: vehicle.isLeasing || ((ref14 = vehicle.vehicleOwner) === null || ref14 === void 0 ? void 0 : ref14.legalType) === "PJ" ? "other" : "owner",
                mainDriverData: RCAProprietar_objectSpread({}, vehicle.vehicleDriver, {
                    idExpirationDate: getYearFromDateString((ref15 = vehicle.vehicleDriver) === null || ref15 === void 0 ? void 0 : ref15.idExpirationDate),
                    driverLicenceDate: getYearFromDateString((ref16 = vehicle.vehicleDriver) === null || ref16 === void 0 ? void 0 : ref16.driverLicenceDate)
                })
            },
            isLeasing: vehicle.isLeasing.toString()
        }, vehicle.isLeasing && ((ref17 = vehicle.vehicleOwner) === null || ref17 === void 0 ? void 0 : ref17.cif) && {
            leasingCompanyCif: vehicle.vehicleOwner.cif
        }) : {
            legalType: "PF",
            companyDataSection: {},
            userDataSection: {},
            mainDriverSection: {
                mainDriver: "owner",
                mainDriverData: {}
            },
            isLeasing: "false"
        };
    }, [
        selectedVehicle,
        savedVehicles,
        formData.proprietarForm
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Form */.l0, {
        initialValues: initialValues,
        onSubmit: onSubmit,
        render: function(param2) {
            var handleSubmit = param2.handleSubmit, form = param2.form, values1 = param2.values;
            var isLeasing = values1.isLeasing === "true";
            var isCompany = values1.legalType === "PJ";
            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "space-y-[20px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                as: "h4",
                                title: "Date despre proprietar",
                                display: "h2",
                                sameSizeOnMobile: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* FormSpy */.lP, {
                                subscription: {
                                    values: true
                                },
                                onChange: function(param) {
                                    var values = param.values;
                                    return handleFormValuesChange({
                                        values: values,
                                        form: form
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RCAProprietar_OwnerTypeSection, {
                                values: values1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RCAProprietar_LeasingSection, {
                                isLeasing: isLeasing,
                                apiData: apiData,
                                values: values1
                            }),
                            isCompany && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bg-white p-[16px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RCAProprietar_CompanyDataSection, {
                                    form: form,
                                    apiData: apiData
                                })
                            }),
                            !isCompany && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bg-white p-[16px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RCAProprietar_OwnerDataSection, {
                                    form: form,
                                    apiData: apiData
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RCAProprietar_MainDriverSection, {
                                values: values1,
                                isCompany: isCompany
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bg-white pt-[20px] -mx-[15px] lg:-mx-[20px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "bg-[#F5FBF4] px-[15px] lg:px-[20px] py-[20px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RCAProprietar_GdprConsentSection, {})
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pt-[20px] text-center -mx-[15px] lg:-mx-[20px] -mb-[20px] bg-white",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: "secondary",
                            type: "submit",
                            title: "Pasul urmator",
                            classesProp: "min-w-[300px] text-[20px] font-medium",
                            hasMinWidth: true
                        })
                    })
                ]
            }));
        }
    }, "RCAProprietarForm"));
};
/* harmony default export */ var RCA_RCAProprietar = ((0,es/* connect */.$j)(null, {
    addAlert: actions/* addAlert */.V_
})(RCAProprietar));

// EXTERNAL MODULE: ./components/Alert.js + 10 modules
var Alert = __webpack_require__(16479);
;// CONCATENATED MODULE: ./containers/RCA/RCAVehicul/VehicleStateSection.js






var VehicleStateSection_ref = (0,config["default"])(), VehicleStateSection_publicRuntimeConfig = VehicleStateSection_ref.publicRuntimeConfig, websiteName = VehicleStateSection_publicRuntimeConfig.settings.websiteName;
var VehicleStateSection = function(param) {
    var values = param.values;
    var ref3, ref1, ref2;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: "space-y-[10px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-sm font-medium",
                children: [
                    "Stare vehicul ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-red-brand",
                        children: "*"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-1 md:grid-cols-2 gap-[16px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("flex items-center p-[16px] bg-white", {
                            "border border-[#99CE88]": Number((ref3 = values.vehicle) === null || ref3 === void 0 ? void 0 : ref3.vehicleRegistrationStatus) === 1
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                            name: "vehicle.vehicleRegistrationStatus",
                            type: "radio",
                            value: "1",
                            component: Radio/* default */.Z,
                            label: "Inmatriculat",
                            className: "cursor-pointer w-full mb-0",
                            labelClass: "font-normal text-[14px]"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("flex items-center p-[16px] bg-white", {
                            "border border-[#99CE88]": Number((ref1 = values.vehicle) === null || ref1 === void 0 ? void 0 : ref1.vehicleRegistrationStatus) === 2
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                            name: "vehicle.vehicleRegistrationStatus",
                            type: "radio",
                            value: "2",
                            component: Radio/* default */.Z,
                            label: "In vederea inmatricularii",
                            className: "cursor-pointer w-full mb-0",
                            labelClass: "font-normal text-[14px]"
                        })
                    })
                ]
            }),
            Number((ref2 = values.vehicle) === null || ref2 === void 0 ? void 0 : ref2.vehicleRegistrationStatus) === 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                type: "warning",
                showIcon: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "text-[14px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Atentie!"
                        }),
                        " Pentru emiterea politei RCA „in vederea inmatricularii”, este necesar sa trimiteti un document care atesta achizitia vehiculului (contract de vanzare-cumparare, factura sau alt document justificativ) la adresa:",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                            children: [
                                "asigurari@",
                                websiteName,
                                ".ro"
                            ]
                        }),
                        ". Polita va fi emisa doar dupa verificarea documentelor."
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var RCAVehicul_VehicleStateSection = (VehicleStateSection);

// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(42298);
// EXTERNAL MODULE: ./components/CustomDatePicker.js
var CustomDatePicker = __webpack_require__(27902);
;// CONCATENATED MODULE: ./containers/RCA/RCAVehicul/VehicleDataSection.js









function VehicleDataSection_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function VehicleDataSection_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            VehicleDataSection_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var VehicleDataSection_INPUT_CLASS = "!max-w-full !min-w-0";
var VehicleDataSection = function(param1) {
    var apiData = param1.apiData, form = param1.form, getFormData = param1.getFormData, onFormDataUpdate = param1.onFormDataUpdate, formData = param1.formData;
    var ref3, ref1;
    var vehicleCategories = apiData.vehicleCategories, vehicleSubcategories = apiData.vehicleSubcategories, vehicleBrands = apiData.vehicleBrands, vehicleFuelTypes = apiData.vehicleFuelTypes, vehicleActivityTypes = apiData.vehicleActivityTypes;
    var values = form.getState().values;
    var isElectricMotor = (0,react.useMemo)(function() {
        var ref, ref2;
        if (!((ref = values.vehicle) === null || ref === void 0 ? void 0 : ref.fuelTypeId) || !vehicleFuelTypes) {
            return false;
        }
        var selectedFuelType = vehicleFuelTypes.find(function(type) {
            return type.id === Number(values.vehicle.fuelTypeId);
        });
        return selectedFuelType === null || selectedFuelType === void 0 ? void 0 : (ref2 = selectedFuelType.name) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase().includes("electric");
    }, [
        (ref3 = values.vehicle) === null || ref3 === void 0 ? void 0 : ref3.fuelTypeId,
        vehicleFuelTypes
    ]);
    (0,react.useEffect)(function() {
        if (isElectricMotor) {
            form.change("vehicle.engineCapacity", "1");
        }
    }, [
        isElectricMotor,
        form
    ]);
    var vehicleCategoriesOptions = (0,react.useMemo)(function() {
        return vehicleCategories ? vehicleCategories.map(function(param) {
            var id = param.id, name = param.name;
            return {
                value: id,
                label: name
            };
        }) : [];
    }, [
        vehicleCategories
    ]);
    var vehicleSubcategoriesOptions = (0,react.useMemo)(function() {
        return vehicleSubcategories && values.vehicle.vehicleCategoryId && vehicleSubcategories[values.vehicle.vehicleCategoryId] ? vehicleSubcategories[values.vehicle.vehicleCategoryId].map(function(param) {
            var id = param.id, name = param.name;
            return {
                value: id,
                label: name
            };
        }) : [];
    }, [
        vehicleSubcategories,
        values.vehicle.vehicleCategoryId
    ]);
    var vehicleBrandsOptions = (0,react.useMemo)(function() {
        return vehicleBrands ? vehicleBrands.map(function(param) {
            var id = param.id, name = param.name;
            return {
                value: id,
                label: name
            };
        }) : [];
    }, [
        vehicleBrands
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_final_form_es/* Field */.gN, {
                    name: "vehicle.vehicleCategoryId",
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)()),
                    component: Select/* default */.Z,
                    label: "Categorie vehicul",
                    required: true,
                    labelClass: "text-[14px]",
                    inputClassName: VehicleDataSection_INPUT_CLASS,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                            value: "",
                            children: "alege"
                        }),
                        vehicleCategoriesOptions && vehicleCategoriesOptions.map(function(param) {
                            var value = param.value, label = param.label;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                value: value,
                                children: label
                            }, value);
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_final_form_es/* Field */.gN, {
                    name: "vehicle.vehicleSubCategoryId",
                    label: "Subcategorie vehicul",
                    component: Select/* default */.Z,
                    required: true,
                    disabled: !values.vehicle.vehicleCategoryId,
                    labelClass: "text-[14px]",
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)()),
                    inputClassName: VehicleDataSection_INPUT_CLASS,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                            value: "",
                            children: "alege"
                        }),
                        vehicleSubcategoriesOptions && vehicleSubcategoriesOptions.map(function(param) {
                            var value = param.value, label = param.label;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                value: value,
                                children: label
                            }, value);
                        })
                    ]
                })
            }),
            ((ref1 = values.vehicle) === null || ref1 === void 0 ? void 0 : ref1.vehicleRegistrationStatus) === "1" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    name: "vehicle.plateNo",
                    component: InputText/* default */.Z,
                    label: "Nr. de inmatriculare",
                    required: true,
                    placeholder: "B 000 ABC",
                    labelClass: "text-[14px]",
                    inputClassName: VehicleDataSection_INPUT_CLASS,
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* isVehiclePlateNumber */.Si)())
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    name: "vehicle.vin",
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)()),
                    children: function(param) {
                        var input = param.input, meta = param.meta;
                        var ref;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(InputText/* default */.Z, {
                            input: VehicleDataSection_objectSpread({}, input, {
                                value: input.value,
                                onChange: function(e) {
                                    var value = e.target.value;
                                    if ((value === null || value === void 0 ? void 0 : value.length) > 17) {
                                        return;
                                    }
                                    input.onChange(value);
                                    if (value.trim().length === 17) {
                                        getFormData({
                                            type: "vinCheckData",
                                            payload: {
                                                vin: value,
                                                form: form
                                            }
                                        });
                                    }
                                }
                            }),
                            meta: meta,
                            label: "Serie sasiu",
                            required: true,
                            max: "17",
                            inputClassName: VehicleDataSection_INPUT_CLASS,
                            disabled: ((ref = values.vin) === null || ref === void 0 ? void 0 : ref.length) > 17,
                            placeholder: "Introdu seria de sasiu",
                            labelClass: "text-[14px]"
                        });
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    name: "vehicle.makeId",
                    label: "Marca",
                    required: true,
                    labelClass: "text-[14px]",
                    component: SelectSearch/* default */.Z,
                    placeholder: "alege",
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)()),
                    parse: function(option) {
                        return option.value;
                    },
                    format: function(value) {
                        return vehicleBrandsOptions.find(function(option) {
                            return option.value === value;
                        });
                    },
                    options: vehicleBrandsOptions,
                    controlClassName: VehicleDataSection_INPUT_CLASS
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    name: "vehicle.commercialName",
                    component: InputText/* default */.Z,
                    label: "Model",
                    required: true,
                    placeholder: "Introdu modelul",
                    labelClass: "text-[14px]",
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)()),
                    inputClassName: VehicleDataSection_INPUT_CLASS
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    name: "vehicle.productionYear",
                    component: InputText/* default */.Z,
                    type: "number",
                    label: "An fabricatie",
                    required: true,
                    placeholder: new Date().getFullYear().toString(),
                    min: "1900",
                    max: new Date().getFullYear() + 1,
                    labelClass: "text-[14px]",
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* hasMinLength */.vd)(4), (0,validations/* hasMaxLength */.aG)(4), (0,validations/* hasMinVal */.Lg)(1900), (0,validations/* hasMaxVal */.jT)(new Date().getFullYear())),
                    inputClassName: VehicleDataSection_INPUT_CLASS
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_final_form_es/* Field */.gN, {
                    name: "vehicle.fuelTypeId",
                    label: "Tip motor",
                    required: true,
                    labelClass: "text-[14px]",
                    component: Select/* default */.Z,
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)()),
                    inputClassName: VehicleDataSection_INPUT_CLASS,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                            value: "",
                            children: "alege"
                        }),
                        vehicleFuelTypes && vehicleFuelTypes.map(function(param) {
                            var id = param.id, name = param.name;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                value: id,
                                children: name
                            }, id);
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    name: "vehicle.engineCapacity",
                    component: InputText/* default */.Z,
                    label: "Capacitate cilindrica",
                    type: "number",
                    required: true,
                    placeholder: "1234",
                    min: "1",
                    labelClass: "text-[14px]",
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* hasMinVal */.Lg)(1)),
                    inputClassName: VehicleDataSection_INPUT_CLASS,
                    disabled: isElectricMotor
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    name: "vehicle.maxWeight",
                    component: InputText/* default */.Z,
                    label: "Masa maxima",
                    type: "number",
                    required: true,
                    placeholder: "1234",
                    min: "1",
                    labelClass: "text-[14px]",
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* hasMinVal */.Lg)(1)),
                    inputClassName: VehicleDataSection_INPUT_CLASS
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    name: "vehicle.enginePowerKw",
                    component: InputText/* default */.Z,
                    label: "Putere (kW)",
                    type: "number",
                    required: true,
                    placeholder: "123",
                    min: "1",
                    labelClass: "text-[14px]",
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* hasMinVal */.Lg)(1)),
                    inputClassName: VehicleDataSection_INPUT_CLASS
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    name: "vehicle.seatsNumber",
                    component: InputText/* default */.Z,
                    label: "Nr. locuri",
                    type: "number",
                    required: true,
                    placeholder: "5",
                    min: "1",
                    labelClass: "text-[14px]",
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* hasMinVal */.Lg)(1)),
                    inputClassName: VehicleDataSection_INPUT_CLASS
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-1 md:col-span-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    name: "vehicle.civ",
                    component: InputText/* default */.Z,
                    label: "Serie CIV",
                    required: true,
                    placeholder: "Introdu seria cartii de identitate a vehiculului",
                    labelClass: "text-[14px]",
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* isAlphaNumeric */.bJ)(), (0,validations/* hasMinLength */.vd)(7), (0,validations/* hasMaxLength */.aG)(7)),
                    inputClassName: VehicleDataSection_INPUT_CLASS
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-[14px] Form-label is-required font-medium mb-[4px]",
                        children: "Data expirare ITP"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomDatePicker/* default */.Z, {
                        selected: formData.vehicle.itpExpiration ? new Date(formData.vehicle.itpExpiration) : null,
                        onChange: function(date) {
                            onFormDataUpdate({
                                vehicle: VehicleDataSection_objectSpread({}, formData.vehicle, {
                                    itpExpiration: (0,format["default"])(date, "yyyy-MM-dd'T'00:00:00")
                                })
                            });
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    name: "vehicle.graweKilometraj",
                    component: InputText/* default */.Z,
                    type: "number",
                    label: "Numar de km",
                    required: true,
                    placeholder: "Introdu numarul de km",
                    labelClass: "text-[14px]",
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* hasMinVal */.Lg)(0)),
                    inputClassName: VehicleDataSection_INPUT_CLASS
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_final_form_es/* Field */.gN, {
                    name: "vehicle.activityTypeId",
                    validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)()),
                    required: true,
                    label: "Tip utilizare vehicul",
                    component: Select/* default */.Z,
                    labelClass: "text-[14px]",
                    inputClassName: VehicleDataSection_INPUT_CLASS,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                            value: "",
                            children: "alege"
                        }),
                        vehicleActivityTypes && vehicleActivityTypes.map(function(type) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                value: type.id,
                                children: type.name
                            }, type.id);
                        })
                    ]
                })
            })
        ]
    }));
};
/* harmony default export */ var RCAVehicul_VehicleDataSection = (VehicleDataSection);

// EXTERNAL MODULE: ./components/Modal.js
var Modal = __webpack_require__(12280);
;// CONCATENATED MODULE: ./containers/RCA/RCAVehicul/CivExampleModal.js



var CivExampleModal_ref = (0,config["default"])(), CivExampleModal_publicRuntimeConfig = CivExampleModal_ref.publicRuntimeConfig, cdn = CivExampleModal_publicRuntimeConfig.settings.cdn;
var CivExampleModal = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Modal["default"], {
        id: "CivExampleModal",
        header: "Legenda talon",
        size: "large",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: "".concat(cdn, "/media/rca/talon.png"),
            alt: "Exemplu certificat de inmatriculare",
            className: "w-full"
        })
    });
};
/* harmony default export */ var RCAVehicul_CivExampleModal = (CivExampleModal);

;// CONCATENATED MODULE: ./containers/RCA/RCAVehicul/index.js













function RCAVehicul_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function RCAVehicul_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                RCAVehicul_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                RCAVehicul_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function RCAVehicul_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function RCAVehicul_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            RCAVehicul_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function RCAVehicul_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = RCAVehicul_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function RCAVehicul_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var RCAVehicul = function(param1) {
    var apiData = param1.apiData, onFormDataUpdate = param1.onFormDataUpdate, onApiDataUpdate = param1.onApiDataUpdate, onStepChange = param1.onStepChange, onLoadingStateChange = param1.onLoadingStateChange, formData = param1.formData, addAlert1 = param1.addAlert, onErrorsUpdate = param1.onErrorsUpdate, addModal1 = param1.addModal;
    var initialValues = (0,react.useMemo)(function() {
        var ref;
        return {
            vehicle: RCAVehicul_objectSpread({}, formData.vehicle, {
                vehicleRegistrationStatus: ((ref = formData.vehicle) === null || ref === void 0 ? void 0 : ref.vehicleRegistrationStatus) || "1"
            })
        };
    }, []);
    (0,react.useEffect)(function() {
        var getInitialData = function() {
            var _ref = RCAVehicul_asyncToGenerator(runtime_default().mark(function _callee() {
                var promises;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            onLoadingStateChange(true);
                            promises = [];
                            if (!apiData.vehicleCategories) {
                                promises.push(fetchVehicleCategories());
                            }
                            if (!apiData.vehicleBrands) {
                                promises.push(fetchVehicleBrands());
                            }
                            if (!apiData.vehicleFuelTypes) {
                                promises.push(fetchFuelTypes());
                            }
                            if (!apiData.vehicleActivityTypes) {
                                promises.push(fetchVehicleActivityTypes());
                            }
                            _ctx.next = 8;
                            return Promise.all(promises);
                        case 8:
                            onLoadingStateChange(false);
                        case 9:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function getInitialData() {
                return _ref.apply(this, arguments);
            };
        }();
        if (!(apiData.vehicleCategories || apiData.vehicleBrands || apiData.vehicleFuelTypes || apiData.vehicleActivityTypes)) {
            getInitialData();
        }
    }, []);
    var fetchVehicleSubcategories = function() {
        var _ref = RCAVehicul_asyncToGenerator(runtime_default().mark(function _callee(param) {
            var categoryId, ref, response1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        categoryId = param.categoryId;
                        ;
                        _ctx.next = 4;
                        return (0,helpers/* makeApiCall */.Vo)({
                            apiCall: api/* getSubCategoriesVehicleApi */.$CA,
                            apiArgs: [
                                categoryId
                            ],
                            formatResponse: function(response) {
                                return response.data.data;
                            },
                            preFail: function() {
                                addAlert1({
                                    message: "Nu am putut incarca subcategoriile de vehicule.",
                                    variant: "error"
                                });
                                onErrorsUpdate({
                                    message: "Nu am putut incarca subcategoriile de vehicule.",
                                    variant: "error"
                                });
                            }
                        });
                    case 4:
                        response1 = _ctx.sent;
                        if (response1 === null || response1 === void 0 ? void 0 : (ref = response1.items) === null || ref === void 0 ? void 0 : ref.length) {
                            onApiDataUpdate({
                                vehicleSubcategories: RCAVehicul_objectSpread({}, apiData.vehicleSubcategories, RCAVehicul_defineProperty({}, categoryId, response1.items))
                            });
                        }
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchVehicleSubcategories(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var fetchVehicleCategories = function() {
        var _ref = RCAVehicul_asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, response2;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return (0,helpers/* makeApiCall */.Vo)({
                            apiCall: api/* getCategoriesVehicleApi */.dm7,
                            formatResponse: function(response) {
                                return response.data.data;
                            },
                            preFail: function() {
                                addAlert1({
                                    message: "Nu am putut incarca categoriile de vehicule.",
                                    variant: "error"
                                });
                                onErrorsUpdate({
                                    message: "Nu am putut incarca categoriile de vehicule.",
                                    variant: "error"
                                });
                            }
                        });
                    case 3:
                        response2 = _ctx.sent;
                        if (response2 === null || response2 === void 0 ? void 0 : (ref = response2.items) === null || ref === void 0 ? void 0 : ref.length) {
                            onApiDataUpdate({
                                vehicleCategories: response2.items
                            });
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchVehicleCategories() {
            return _ref.apply(this, arguments);
        };
    }();
    var fetchVehicleBrands = function() {
        var _ref = RCAVehicul_asyncToGenerator(runtime_default().mark(function _callee() {
            var response3;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,helpers/* makeApiCall */.Vo)({
                            apiCall: api/* getBrandsVehicleApi */.CIq,
                            formatResponse: function(response) {
                                return response.data.data.items.sort(function(a, b) {
                                    return a.name.trim().localeCompare(b.name.trim());
                                });
                            },
                            preFail: function() {
                                addAlert1({
                                    message: "Nu am putut incarca marcile de vehicule.",
                                    variant: "error"
                                });
                                onErrorsUpdate({
                                    message: "Nu am putut incarca marcile de vehicule.",
                                    variant: "error"
                                });
                            }
                        });
                    case 2:
                        response3 = _ctx.sent;
                        if (response3 === null || response3 === void 0 ? void 0 : response3.length) {
                            onApiDataUpdate({
                                vehicleBrands: response3
                            });
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchVehicleBrands() {
            return _ref.apply(this, arguments);
        };
    }();
    var fetchFuelTypes = function() {
        var _ref = RCAVehicul_asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, response4;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return (0,helpers/* makeApiCall */.Vo)({
                            apiCall: api/* getFuelTypesVehicleApi */._yS,
                            formatResponse: function(response) {
                                return response.data.data;
                            },
                            preFail: function() {
                                addAlert1({
                                    message: "Nu am putut incarca tipurile de combustibil.",
                                    variant: "error"
                                });
                                onErrorsUpdate({
                                    message: "Nu am putut incarca tipurile de combustibil.",
                                    variant: "error"
                                });
                            }
                        });
                    case 3:
                        response4 = _ctx.sent;
                        if (response4 === null || response4 === void 0 ? void 0 : (ref = response4.items) === null || ref === void 0 ? void 0 : ref.length) {
                            onApiDataUpdate({
                                vehicleFuelTypes: response4.items
                            });
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchFuelTypes() {
            return _ref.apply(this, arguments);
        };
    }();
    var fetchVehicleActivityTypes = function() {
        var _ref = RCAVehicul_asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, response5;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return (0,helpers/* makeApiCall */.Vo)({
                            apiCall: api/* getActivityTypesRCAApi */.Cub,
                            formatResponse: function(response) {
                                return response.data.data;
                            },
                            preFail: function() {
                                addAlert1({
                                    message: "Nu am putut incarca tipurile de activitati ale vehiculului.",
                                    variant: "error"
                                });
                                onErrorsUpdate({
                                    message: "Nu am putut incarca tipurile de activitati ale vehiculului.",
                                    variant: "error"
                                });
                            }
                        });
                    case 3:
                        response5 = _ctx.sent;
                        if (response5 === null || response5 === void 0 ? void 0 : (ref = response5.items) === null || ref === void 0 ? void 0 : ref.length) {
                            onApiDataUpdate({
                                vehicleActivityTypes: response5.items
                            });
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchVehicleActivityTypes() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleVinCheck = function() {
        var _ref = RCAVehicul_asyncToGenerator(runtime_default().mark(function _callee(param) {
            var vin, form, ref, newVinData, response6, vehicleBrand;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        vin = param.vin, form = param.form;
                        ;
                        if (!(vin.length < 17)) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        newVinData = {};
                        if (!(apiData.vinData && apiData.vinData.vin.trim().toLowerCase() === vin.trim().toLowerCase())) {
                            _ctx.next = 9;
                            break;
                        }
                        {
                            newVinData = apiData.vinData;
                        }
                        _ctx.next = 15;
                        break;
                    case 9:
                        onLoadingStateChange(true);
                        _ctx.next = 12;
                        return (0,helpers/* makeApiCall */.Vo)({
                            apiCall: api/* checkVinVehicleApi */.xtR,
                            apiArgs: [
                                vin
                            ],
                            formatResponse: function(response) {
                                return response.data.data;
                            },
                            preFail: function() {
                                addAlert1({
                                    message: "Nu am putut verifica VIN-ul. Va rugam verificati si incercati din nou.",
                                    variant: "error"
                                });
                            }
                        });
                    case 12:
                        response6 = _ctx.sent;
                        if (response6) {
                            onApiDataUpdate({
                                vinData: response6
                            });
                            newVinData = response6;
                        }
                        onLoadingStateChange(false);
                    case 15:
                        if (!(newVinData.vehicleCategoryId && !((ref = apiData.vehicleSubcategories) === null || ref === void 0 ? void 0 : ref[newVinData.vehicleCategoryId]))) {
                            _ctx.next = 18;
                            break;
                        }
                        _ctx.next = 18;
                        return getFormData({
                            type: "vehicleSubcategoriesData",
                            payload: {
                                categoryId: newVinData.vehicleCategoryId
                            }
                        });
                    case 18:
                        if (newVinData.makeId) {
                            vehicleBrand = apiData.vehicleBrands.find(function(brand) {
                                return brand.id === newVinData.makeId;
                            });
                            if (vehicleBrand) {
                                form.change("vehicle.makeId", vehicleBrand.id);
                            }
                        }
                        if (newVinData) {
                            form.change("vehicle.vehicleCategoryId", newVinData.vehicleCategoryId);
                            form.change("vehicle.commercialName", newVinData.commercialName);
                            form.change("vehicle.vehicleSubCategoryId", newVinData.vehicleSubCategoryId);
                            form.change("vehicle.productionYear", newVinData.productionYear);
                            form.change("vehicle.fuelTypeId", newVinData.fuelId);
                            form.change("vehicle.engineCapacity", newVinData.engineCapacity);
                            form.change("vehicle.enginePowerKw", newVinData.enginePowerKw);
                            form.change("vehicle.maxWeight", newVinData.maxWeight);
                            form.change("vehicle.seatsNumber", newVinData.seatsNumber);
                        }
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleVinCheck(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var getFormData = function() {
        var _ref = RCAVehicul_asyncToGenerator(runtime_default().mark(function _callee(param) {
            var type, payload;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        type = param.type, payload = param.payload;
                        onLoadingStateChange(true);
                        _ctx.t0 = type;
                        _ctx.next = _ctx.t0 === "vehicleSubcategoriesData" ? 5 : _ctx.t0 === "vinCheckData" ? 8 : 11;
                        break;
                    case 5:
                        _ctx.next = 7;
                        return fetchVehicleSubcategories(payload);
                    case 7:
                        return _ctx.abrupt("break", 12);
                    case 8:
                        _ctx.next = 10;
                        return handleVinCheck(payload);
                    case 10:
                        return _ctx.abrupt("break", 12);
                    case 11:
                        return _ctx.abrupt("break", 12);
                    case 12:
                        onLoadingStateChange(false);
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getFormData(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleFormDataChange = function(param) {
        var values = param.values;
        var ref;
        // Save form data for retention, but only if changed
        if (JSON.stringify(values.vehicle) !== JSON.stringify(formData.vehicle)) {
            onFormDataUpdate({
                vehicle: RCAVehicul_objectSpread({}, formData.vehicle, values.vehicle)
            });
        }
        if (values.vehicle.vehicleCategoryId && !((ref = apiData.vehicleSubcategories) === null || ref === void 0 ? void 0 : ref[values.vehicle.vehicleCategoryId])) {
            getFormData({
                type: "vehicleSubcategoriesData",
                payload: {
                    categoryId: values.vehicle.vehicleCategoryId
                }
            });
        }
    };
    var onSubmit = function(values) {
        var _vehicle = values.vehicle, fullDetailsFetched = _vehicle.fullDetailsFetched, vehicleCategoryId = _vehicle.vehicleCategoryId, vehicleSubCategoryId = _vehicle.vehicleSubCategoryId, vehicleRegistrationStatus = _vehicle.vehicleRegistrationStatus, makeId = _vehicle.makeId, fuelTypeId = _vehicle.fuelTypeId, productionYear = _vehicle.productionYear, engineCapacity = _vehicle.engineCapacity, maxWeight = _vehicle.maxWeight, enginePowerKw = _vehicle.enginePowerKw, seatsNumber = _vehicle.seatsNumber, graweKilometraj = _vehicle.graweKilometraj, activityTypeId = _vehicle.activityTypeId, vehicleData = RCAVehicul_objectWithoutProperties(_vehicle, [
            "fullDetailsFetched",
            "vehicleCategoryId",
            "vehicleSubCategoryId",
            "vehicleRegistrationStatus",
            "makeId",
            "fuelTypeId",
            "productionYear",
            "engineCapacity",
            "maxWeight",
            "enginePowerKw",
            "seatsNumber",
            "graweKilometraj",
            "activityTypeId"
        ]);
        var payload = {
            vehicle: RCAVehicul_objectSpread({}, vehicleData, {
                vehicleCategoryId: Number(vehicleCategoryId),
                vehicleSubCategoryId: Number(vehicleSubCategoryId),
                vehicleRegistrationStatus: Number(vehicleRegistrationStatus),
                makeId: Number(makeId),
                productionYear: Number(productionYear),
                fuelTypeId: Number(fuelTypeId),
                engineCapacity: Number(engineCapacity),
                maxWeight: Number(maxWeight),
                enginePowerKw: Number(enginePowerKw),
                seatsNumber: Number(seatsNumber),
                graweKilometraj: Number(graweKilometraj),
                activityTypeId: Number(activityTypeId),
                itpExpiration: formData.vehicle.itpExpiration
            })
        };
        onFormDataUpdate(payload);
        onStepChange(4);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Form */.l0, {
                onSubmit: onSubmit,
                initialValues: initialValues,
                render: function(param2) {
                    var handleSubmit = param2.handleSubmit, values1 = param2.values, form = param2.form;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("form", {
                        onSubmit: handleSubmit,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "space-y-[20px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                        as: "h4",
                                        title: "Date despre autovehicul",
                                        display: "h2",
                                        sameSizeOnMobile: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* FormSpy */.lP, {
                                        subscription: {
                                            values: true
                                        },
                                        onChange: function(param) {
                                            var values = param.values;
                                            handleFormDataChange({
                                                values: values
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RCAVehicul_VehicleStateSection, {
                                        values: values1
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bg-white p-[16px] text-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            type: "button",
                                            onClick: function() {
                                                return addModal1("CivExampleModal");
                                            },
                                            title: "Legenda talon",
                                            isCatalog: true,
                                            variant: "third"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bg-white p-[16px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RCAVehicul_VehicleDataSection, {
                                            form: form,
                                            apiData: apiData,
                                            getFormData: getFormData,
                                            onFormDataUpdate: onFormDataUpdate,
                                            formData: formData
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pt-[20px] mt-[20px] text-center -mx-[15px] lg:-mx-[20px] -mb-[20px] bg-white",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: "secondary",
                                    type: "submit",
                                    title: "Pasul urmator",
                                    classesProp: "min-w-[300px] text-[20px] font-medium",
                                    hasMinWidth: true,
                                    disabled: form.getState().invalid || !formData.vehicle.itpExpiration
                                })
                            })
                        ]
                    });
                }
            }, "RCAVehiculForm"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RCAVehicul_CivExampleModal, {})
        ]
    }));
};
/* harmony default export */ var RCA_RCAVehicul = ((0,es/* connect */.$j)(null, {
    addAlert: actions/* addAlert */.V_,
    addModal: actions/* addModal */.Y_
})(RCAVehicul));

// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(65988);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/getMonth/index.js
var getMonth = __webpack_require__(78966);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/ro/index.js + 5 modules
var ro = __webpack_require__(88397);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.min.js
var react_datepicker_min = __webpack_require__(9198);
var react_datepicker_min_default = /*#__PURE__*/__webpack_require__.n(react_datepicker_min);
// EXTERNAL MODULE: ./components/Icons/Arrow.js
var Arrow = __webpack_require__(91621);
;// CONCATENATED MODULE: ./containers/RCA/RCADataPolita.js














function RCADataPolita_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function RCADataPolita_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                RCADataPolita_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                RCADataPolita_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function RCADataPolita_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function RCADataPolita_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            RCADataPolita_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function RCADataPolita_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = RCADataPolita_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function RCADataPolita_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
(0,react_datepicker_min.registerLocale)("ro", ro/* default */.Z);
var toInt = function(val) {
    var num = Number(val);
    return isNaN(num) ? 0 : num;
};
var RCADataPolita = function(param1) {
    var formData = param1.formData, addAlert1 = param1.addAlert, onFormDataUpdate = param1.onFormDataUpdate, onApiDataUpdate = param1.onApiDataUpdate, onStepChange = param1.onStepChange, onLoadingStateChange = param1.onLoadingStateChange;
    var ref7, ref1, ref2, ref3, ref4, ref5, ref6;
    (0,react.useEffect)(function() {
        if (!formData.startDate) {
            // Set default selected date to tomorrow at midnight
            var tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            onFormDataUpdate({
                startDate: (0,format["default"])(tomorrow, "yyyy-MM-dd'T'00:00:00")
            });
        }
    }, []);
    var handleSubmit = function() {
        var _ref = RCADataPolita_asyncToGenerator(runtime_default().mark(function _callee(e) {
            var _vehicle, oldSubCatId, firstRegistration, vignetteExpiration, itpExpiration, vehiclePayload, payload, response1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        if (formData.startDate) {
                            _ctx.next = 4;
                            break;
                        }
                        addAlert1({
                            message: "Va rugam selectati o data de incepere a politei.",
                            variant: "error"
                        });
                        return _ctx.abrupt("return");
                    case 4:
                        onLoadingStateChange(true);
                        _vehicle = formData.vehicle, oldSubCatId = _vehicle.vehicleSubcategoryId, firstRegistration = _vehicle.firstRegistration, vignetteExpiration = _vehicle.vignetteExpiration, itpExpiration = _vehicle.itpExpiration, vehiclePayload = RCADataPolita_objectWithoutProperties(_vehicle, [
                            "vehicleSubcategoryId",
                            "firstRegistration",
                            "vignetteExpiration",
                            "itpExpiration"
                        ]);
                        payload = RCADataPolita_objectSpread({}, formData, {
                            vehicle: RCADataPolita_objectSpread({}, vehiclePayload, {
                                vehicleCategoryId: toInt(vehiclePayload.vehicleCategoryId),
                                vehicleRegistrationStatus: toInt(vehiclePayload.vehicleRegistrationStatus),
                                activityTypeId: toInt(vehiclePayload.activityTypeId),
                                vehicleSubCategoryId: toInt(vehiclePayload.vehicleSubCategoryId || oldSubCatId)
                            }, firstRegistration && {
                                firstRegistration: (0,format["default"])(new Date(firstRegistration), "yyyy-MM-dd'T'00:00:00")
                            }, vignetteExpiration && {
                                vignetteExpiration: (0,format["default"])(new Date(vignetteExpiration), "yyyy-MM-dd'T'00:00:00")
                            }, itpExpiration && {
                                itpExpiration: (0,format["default"])(new Date(itpExpiration), "yyyy-MM-dd'T'00:00:00")
                            }, {
                                makeId: toInt(vehiclePayload.makeId),
                                fuelTypeId: toInt(vehiclePayload.fuelTypeId),
                                productionYear: toInt(vehiclePayload.productionYear),
                                engineCapacity: toInt(vehiclePayload.engineCapacity),
                                maxWeight: toInt(vehiclePayload.maxWeight),
                                enginePowerKw: toInt(vehiclePayload.enginePowerKw),
                                seatsNumber: toInt(vehiclePayload.seatsNumber),
                                graweKilometraj: toInt(vehiclePayload.graweKilometraj),
                                registrationTypeId: toInt(vehiclePayload.vehicleRegistrationStatus)
                            })
                        });
                        _ctx.next = 9;
                        return (0,helpers/* makeApiCall */.Vo)({
                            apiCall: api/* createRCAApi */.f8T,
                            apiArgs: [
                                payload
                            ],
                            returnResponse: true,
                            formatResponse: function(response) {
                                return response.data.data;
                            },
                            preFail: function(response) {
                                var ref;
                                addAlert1({
                                    message: (response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.message) || "A aparut o eroare la crearea comenzii RCA.",
                                    variant: "error"
                                });
                            }
                        });
                    case 9:
                        response1 = _ctx.sent;
                        if (response1 === null || response1 === void 0 ? void 0 : response1.id) {
                            onApiDataUpdate({
                                orderId: response1.id
                            });
                            onStepChange(5);
                        }
                        onLoadingStateChange(false);
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var availableDays = (0,react.useMemo)(function() {
        var result = [];
        var start = new Date();
        start.setDate(start.getDate() + 1); // start from tomorrow
        for(var i = 0; i < 60; i++){
            var date = new Date(start);
            date.setDate(start.getDate() + i);
            result.push(date);
        }
        return result;
    }, []);
    var handleDateChange = function(date) {
        onFormDataUpdate({
            startDate: (0,format["default"])(new Date(date), "yyyy-MM-dd'T'00:00:00")
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "space-y-[20px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        as: "h4",
                        display: "h2",
                        sameSizeOnMobile: true,
                        title: "Data de incepere a valabilitatii politei"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bg-white w-full sm:py-[16px] lg:py-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "jsx-bee2755217c1e5fd" + " " + "w-full sm:w-[80%] md:w-[70%] lg:w-full mx-auto",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((react_datepicker_min_default()), {
                                    locale: "ro",
                                    includeDates: availableDays,
                                    inline: true,
                                    selectedDate: formData.startDate,
                                    onChange: function(date) {
                                        return handleDateChange(date);
                                    },
                                    renderCustomHeader: function(param) {
                                        var date = param.date, decreaseMonth = param.decreaseMonth, increaseMonth = param.increaseMonth, prevMonthButtonDisabled = param.prevMonthButtonDisabled, nextMonthButtonDisabled = param.nextMonthButtonDisabled;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                            className: "jsx-bee2755217c1e5fd" + " " + "flex justify-between items-center px-[16px] py-[8px] bg-white",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    type: "button",
                                                    onClick: decreaseMonth,
                                                    disabled: prevMonthButtonDisabled,
                                                    className: "jsx-bee2755217c1e5fd" + " " + "w-6 h-6 center flex justify-center items-center rotate-180 ".concat(prevMonthButtonDisabled ? "opacity-0" : ""),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow/* default */.Z, {
                                                        fill: "#1D4ED8",
                                                        width: "100%",
                                                        height: "100%"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "jsx-bee2755217c1e5fd" + " " + "capitalize text-[20px]",
                                                    children: ro/* default.localize.month */.Z.localize.month((0,getMonth["default"])(date))
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    type: "button",
                                                    onClick: increaseMonth,
                                                    disabled: nextMonthButtonDisabled,
                                                    className: "jsx-bee2755217c1e5fd" + " " + "w-6 h-6 center flex justify-center items-center ".concat(nextMonthButtonDisabled ? "opacity-0" : ""),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow/* default */.Z, {
                                                        fill: "#1D4ED8",
                                                        width: "100%",
                                                        height: "100%"
                                                    })
                                                })
                                            ]
                                        });
                                    }
                                }),
                                (0,jsx_runtime.jsx)((style_default()), {
                                    id: "bee2755217c1e5fd",
                                    children: ".react-datepicker__day-names{display:grid;\ngrid-template-columns:repeat(7, minmax(0, 1fr));\ntext-transform:uppercase;\nbackground-color:#eef9fe;\ntext-align:center}\n.react-datepicker__day-name{padding:10px 20px;\nfont-weight:500}\n.react-datepicker__month{background-color:white}\n.react-datepicker__week{display:grid;\ngrid-template-columns:repeat(7, minmax(0, 1fr))}\n.react-datepicker__day{padding:10px;\nfont-size:16px;\nfont-weight:500;\ntext-align:center;\ncursor:pointer}\n.react-datepicker__day--today{background-color:#eef9fe}\n.react-datepicker__day--disabled{color:#b3b3b3;\npointer-events:none;\ncursor:default}\n.react-datepicker__day--keyboard-selected{background-color:#ffcb05}\n@media (min-width:768px) {.react-datepicker__day{padding:20px;\nfont-size:20px}}"
                                })
                            ]
                        })
                    }),
                    formData.startDate && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-[#808080] text-[14px] pb-[20px]",
                        children: [
                            "Data selectata:",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-black font-medium capitalize",
                                children: (0,format["default"])(new Date(formData.startDate), "dd MMMM", {
                                    locale: ro/* default */.Z
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-white pt-[20px] -mx-[15px] lg:-mx-[20px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bg-[#F5FBF4] px-[15px] lg:px-[20px] pt-[20px]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bg-white p-[16px] flex flex-col lg:flex-row justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-sm",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-[#808080]",
                                                children: "Autovehicul:"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "font-medium",
                                                children: [
                                                    (ref7 = formData.vehicle) === null || ref7 === void 0 ? void 0 : ref7.plateNo,
                                                    " -",
                                                    " ",
                                                    (ref1 = formData.vehicle) === null || ref1 === void 0 ? void 0 : ref1.commercialName
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-[#808080]",
                                                children: "Proprietar:"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "font-medium",
                                                children: "".concat(((ref2 = formData.vehicle.vehicleOwner) === null || ref2 === void 0 ? void 0 : ref2.companyName) || ((ref3 = formData.vehicle.vehicleOwner) === null || ref3 === void 0 ? void 0 : ref3.lastName), " ").concat(((ref4 = formData.vehicle.vehicleOwner) === null || ref4 === void 0 ? void 0 : ref4.firstName) || "")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-[#808080]",
                                                children: "Conducator auto:"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "font-medium",
                                                children: [
                                                    (ref5 = formData.vehicle.vehicleDriver) === null || ref5 === void 0 ? void 0 : ref5.lastName,
                                                    " ",
                                                    (ref6 = formData.vehicle.vehicleDriver) === null || ref6 === void 0 ? void 0 : ref6.firstName
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                className: "text-red-brand underline hover:text-bleu-hover font-medium text-left lg:text-right max-w-fit mt-[20px] lg:mt-0",
                                onClick: function() {
                                    return onStepChange(2);
                                },
                                children: "Modifica"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pt-[20px] mt-[20px] text-center -mx-[15px] lg:-mx-[20px] -mb-[20px] bg-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    variant: "secondary",
                    type: "submit",
                    title: "Pasul urmator",
                    classesProp: "min-w-[300px] text-[20px] font-medium"
                })
            })
        ]
    }));
};
/* harmony default export */ var RCA_RCADataPolita = ((0,es/* connect */.$j)(null, {
    addAlert: actions/* addAlert */.V_
})(RCADataPolita));

;// CONCATENATED MODULE: ./containers/RCA/RCAProprietar/PolicyDeliverySection.js





var PolicyDeliverySection = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
        className: "space-y-[20px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "bg-white p-[16px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                name: "policyDelivery.digitalPolicy",
                component: Checkbox/* default */.Z,
                type: "checkbox",
                label: "Declar ca sunt de acord cu emiterea si transmiterea politei de asigurare in format electronic, la adresa de email furnizata.",
                required: true,
                validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)()),
                className: "text-[14px] font-normal cursor-pointer max-w-fit"
            })
        })
    });
};
/* harmony default export */ var RCAProprietar_PolicyDeliverySection = (PolicyDeliverySection);

;// CONCATENATED MODULE: ./containers/RCA/RcaOffers/RcaOffersPolicyInfo.js

var RcaOffersPolicyInfo = function(param) {
    var vehicle = param.formData.vehicle;
    var ref, ref1, ref2, ref3, ref4;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-[#808080]",
                        children: "Autovehicul:"
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "font-medium",
                        children: [
                            vehicle === null || vehicle === void 0 ? void 0 : vehicle.plateNo,
                            " - ",
                            vehicle === null || vehicle === void 0 ? void 0 : vehicle.commercialName
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-[#808080]",
                        children: "Proprietar:"
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "font-medium",
                        children: "".concat(((ref = vehicle.vehicleOwner) === null || ref === void 0 ? void 0 : ref.companyName) || ((ref1 = vehicle.vehicleOwner) === null || ref1 === void 0 ? void 0 : ref1.lastName) || "", " ").concat(((ref2 = vehicle.vehicleOwner) === null || ref2 === void 0 ? void 0 : ref2.firstName) || "")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-[#808080]",
                        children: "Conducator auto:"
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "font-medium",
                        children: [
                            (ref3 = vehicle.vehicleDriver) === null || ref3 === void 0 ? void 0 : ref3.lastName,
                            " ",
                            (ref4 = vehicle.vehicleDriver) === null || ref4 === void 0 ? void 0 : ref4.firstName
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var RcaOffers_RcaOffersPolicyInfo = (RcaOffersPolicyInfo);

;// CONCATENATED MODULE: ./containers/RCA/RcaOffers/RcaOffersPolicyType.js




var RcaOffersPolicyType = function(param) {
    var values = param.values;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("flex items-center p-[16px] bg-white", {
                    "border border-[#99CE88]": (values === null || values === void 0 ? void 0 : values.withDirectSettlement) === "Yes"
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    name: "withDirectSettlement",
                    type: "radio",
                    value: "Yes",
                    component: Radio/* default */.Z,
                    label: "Cu decontare directa",
                    className: classnames_default()("cursor-pointer w-full mb-0", {
                        "pointer-events-none cursor-default": values.legalType === "PF"
                    }),
                    labelClass: "font-normal text-[14px]"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("flex items-center p-[16px] bg-white", {
                    "border border-[#99CE88]": (values === null || values === void 0 ? void 0 : values.withDirectSettlement) === "No"
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                    name: "withDirectSettlement",
                    type: "radio",
                    value: "No",
                    component: Radio/* default */.Z,
                    label: "Fara decontare directa",
                    className: classnames_default()("cursor-pointer w-full mb-0", {
                        "pointer-events-none cursor-default": values.legalType === "PJ"
                    }),
                    labelClass: "font-normal text-[14px]"
                })
            })
        ]
    });
};
/* harmony default export */ var RcaOffers_RcaOffersPolicyType = (RcaOffersPolicyType);

// EXTERNAL MODULE: ./lib/helpers.js
var lib_helpers = __webpack_require__(15722);
;// CONCATENATED MODULE: ./containers/RCA/RcaOffers/RcaOffersList/RcaOffersListInfo.js


var BrokerCommissionInfo = function(param) {
    var offerDetails = param.offerDetails, withDirectSettlement = param.withDirectSettlement;
    var standardCommision = offerDetails.brokerCommission, _directSettlement = offerDetails.directSettlement, premiumCommision = _directSettlement.brokerCommission;
    var commision = withDirectSettlement ? (Number(standardCommision.amount) + Number(premiumCommision.amount)).toFixed(2) : standardCommision.amount;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            "Comision inclus in pret: ",
            standardCommision.percent,
            "% (",
            (0,lib_helpers/* formatPrice */.T4)(Number(commision)),
            " lei)"
        ]
    }));
};
var RcaOffersListInfo = function(param) {
    var offer = param.offer, withDirectSettlement = param.withDirectSettlement;
    var _offerDetails = offer.offerDetails, bonusMalusActualClass = _offerDetails.bonusMalusActualClass, referenceTariff = _offerDetails.referenceTariff, exclusionsGreenCard = _offerDetails.exclusionsGreenCard;
    var formatGreenCardExclusions = exclusionsGreenCard.includes(":") ? exclusionsGreenCard.split(":").pop().trim() : exclusionsGreenCard;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            bonusMalusActualClass && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    "Noua clasa Bonus-Malus: ",
                    bonusMalusActualClass
                ]
            }),
            referenceTariff && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    "Tarif de referinta: ",
                    (0,lib_helpers/* formatPrice */.T4)(referenceTariff),
                    " lei"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BrokerCommissionInfo, {
                offerDetails: offer.offerDetails,
                withDirectSettlement: withDirectSettlement
            }),
            exclusionsGreenCard && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    "Tari neacoperite de polita de asigurare: ",
                    formatGreenCardExclusions
                ]
            })
        ]
    }));
};
/* harmony default export */ var RcaOffersList_RcaOffersListInfo = (RcaOffersListInfo);

;// CONCATENATED MODULE: ./containers/RCA/RcaOffers/RcaOffersList/index.js






var RcaOffersList = function(param) {
    var groupedOffers = param.groupedOffers, values = param.values;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: Object.values(groupedOffers).map(function(companyOffer, index) {
            var withDirectSettlement = values.withDirectSettlement === "Yes";
            var companyName = companyOffer.companyName, logoUrl = companyOffer.logoUrl, offers = companyOffer.offers;
            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("flex flex-col sm:flex-row sm:items-center gap-[20px] pb-[20px] border-b border-[#E5E5E5]", {
                    "border-b-0": index === Object.keys(groupedOffers).length - 1
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center justify-center min-w-[25%]",
                        children: logoUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: logoUrl,
                            alt: companyName,
                            className: "max-w-full max-h-full object-contain w-[125px] h-[50px]"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "font-bold text-sm",
                            children: companyName
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-col sm:flex-row gap-[10px] flex-grow",
                        children: offers.filter(function(offer) {
                            return offer.offerDetails.withDirectSettlement === withDirectSettlement;
                        }).map(function(offer) {
                            var offerId = offer.offerId, _offerDetails = offer.offerDetails, periodMonths = _offerDetails.periodMonths, policyPremiumWithDirectSettlement = _offerDetails.policyPremiumWithDirectSettlement, policyPremium = _offerDetails.policyPremium;
                            return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-col gap-[8px] sm:w-[50%]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "bg-[#FAFAFA] p-[16px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                            name: "selectedOffer",
                                            component: Radio/* default */.Z,
                                            type: "radio",
                                            required: true,
                                            value: offerId.toString(),
                                            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex gap-[4px] cursor-pointer",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "text-[14px] font-normal",
                                                        children: [
                                                            periodMonths,
                                                            " ",
                                                            periodMonths === 1 ? "luna" : "luni"
                                                        ]
                                                    }),
                                                    " - ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "text-red-brand font-medium text-[18px]",
                                                        children: [
                                                            (0,lib_helpers/* formatPrice */.T4)(withDirectSettlement ? policyPremiumWithDirectSettlement : policyPremium),
                                                            " ",
                                                            "lei"
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-[12px] mt-[12px]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RcaOffersList_RcaOffersListInfo, {
                                                offer: offer,
                                                withDirectSettlement: withDirectSettlement
                                            })
                                        })
                                    ]
                                })
                            }, offerId));
                        })
                    })
                ]
            }, companyName));
        })
    });
};
/* harmony default export */ var RcaOffers_RcaOffersList = (RcaOffersList);

;// CONCATENATED MODULE: ./containers/RCA/RcaOffers/index.js















function RcaOffers_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function RcaOffers_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                RcaOffers_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                RcaOffers_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var Divider = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
        className: "bg-white -mx-[15px] lg:-mx-[20px] h-[20px]"
    });
};
var RCAOferte = function(param1) {
    var formData = param1.formData, addAlert1 = param1.addAlert, apiData = param1.apiData, onLoadingStateChange = param1.onLoadingStateChange;
    var ref1 = (0,react.useState)(null), offers = ref1[0], setOffers = ref1[1];
    (0,react.useEffect)(function() {
        var fetchOffers = function() {
            var _ref = RcaOffers_asyncToGenerator(runtime_default().mark(function _callee() {
                var response1;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            onLoadingStateChange(true);
                            _ctx.next = 3;
                            return (0,helpers/* makeApiCall */.Vo)({
                                apiCall: api/* getOffersRCAApi */.PK7,
                                apiArgs: [
                                    apiData.orderId
                                ],
                                returnResponse: true,
                                formatResponse: function(response) {
                                    return response.data.data;
                                },
                                preFail: function(response) {
                                    var ref;
                                    addAlert1({
                                        message: ((ref = response.data) === null || ref === void 0 ? void 0 : ref.message) || "A aparut o eroare la incarcarea ofertelor. Va rugam incercati din nou.",
                                        variant: "error"
                                    });
                                }
                            });
                        case 3:
                            response1 = _ctx.sent;
                            if (response1 === null || response1 === void 0 ? void 0 : response1.items) {
                                setOffers(response1.items);
                            }
                            onLoadingStateChange(false);
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetchOffers() {
                return _ref.apply(this, arguments);
            };
        }();
        if (apiData.orderId && !offers) {
            fetchOffers();
        }
    }, [
        apiData.orderId
    ]);
    // Group offers by company
    var groupedOffers = offers && offers.reduce(function(acc, offer) {
        var companyName = offer.productDetails.vendorDetails.commercialName;
        if (!acc[companyName]) {
            acc[companyName] = {
                companyName: companyName,
                logoUrl: offer.productDetails.vendorDetails.linkLogo,
                offers: []
            };
        }
        acc[companyName].offers.push(offer);
        if (acc[companyName].offers.length) {
            acc[companyName].offers.sort(function(a, b) {
                return a.offerDetails.periodMonths - b.offerDetails.periodMonths;
            });
        }
        return acc;
    }, {});
    var handleSubmitOffer = function() {
        var _ref = RcaOffers_asyncToGenerator(runtime_default().mark(function _callee(values) {
            var selectedOffer, payload, response2, paymentLink;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        selectedOffer = values.selectedOffer;
                        if (selectedOffer) {
                            _ctx.next = 4;
                            break;
                        }
                        addAlert1({
                            message: "Va rugam selectati o oferta",
                            variant: "warning"
                        });
                        return _ctx.abrupt("return");
                    case 4:
                        onLoadingStateChange(true);
                        payload = {
                            internal_order_id: apiData.orderId,
                            external_offer_id: Number(selectedOffer)
                        };
                        _ctx.next = 8;
                        return (0,helpers/* makeApiCall */.Vo)({
                            apiCall: api/* paymentInsurranceApi */.tyw,
                            apiArgs: [
                                payload
                            ],
                            formatResponse: function(response) {
                                return response.data.data;
                            },
                            returnResponse: true,
                            preFail: function(response) {
                                var ref;
                                addAlert1({
                                    message: ((ref = response.data) === null || ref === void 0 ? void 0 : ref.message) || "A aparut o eroare la procesarea platii. Va rugam incercati din nou.",
                                    variant: "error"
                                });
                            }
                        });
                    case 8:
                        response2 = _ctx.sent;
                        paymentLink = response2 === null || response2 === void 0 ? void 0 : response2.payment_link;
                        if (paymentLink) {
                            addAlert1({
                                message: "Redirectionare catre pagina de plata...",
                                variant: "info"
                            });
                            window.location.href = paymentLink;
                        }
                        onLoadingStateChange(false);
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmitOffer(values) {
            return _ref.apply(this, arguments);
        };
    }();
    if (!groupedOffers) {
        return null;
    }
    if (groupedOffers && Object.keys(groupedOffers).length === 0) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "p-[24px] bg-white",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                type: "warning",
                showIcon: true,
                children: "Nu am gasit oferte disponibile pentru datele introduse. Va rugam verificati informatiile si incercati din nou."
            })
        }));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Form */.l0, {
        initialValues: {
            withDirectSettlement: "Yes",
            selectedOffer: null
        },
        onSubmit: handleSubmitOffer,
        render: function(param) {
            var values = param.values, handleSubmit = param.handleSubmit;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("form", {
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-sm pb-[20px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RcaOffers_RcaOffersPolicyInfo, {
                            formData: formData
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grid grid-cols-1 md:grid-cols-2 gap-[16px] py-[20px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RcaOffers_RcaOffersPolicyType, {
                            values: values
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "space-y-[16px] -mx-[15px] lg:-mx-[20px] -pb-[20px] bg-white",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RcaOffers_RcaOffersList, {
                            values: values,
                            groupedOffers: groupedOffers
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "py-[16px] text-[14px]",
                        children: [
                            "Pentru verificarea tarfilor de referinta, va rugam accesati adresa",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "text-red-brand font-medium hover:text-bleu-hover",
                                href: "https://www.baar.ro/asigurati-cu-risc-ridicat/",
                                target: "_blank",
                                title: "Tarife de referinta",
                                rel: "noopener noreferrer",
                                children: "https://www.baar.ro/asigurati-cu-risc-ridicat/"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "space-y-[20px] py-[20px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                as: "h4",
                                display: "h2",
                                sameSizeOnMobile: true,
                                title: "Livrarea politei si prelucrarea datelor"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bg-white p-[16px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RCAProprietar_PolicyDeliverySection, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pt-[20px] text-center -mx-[15px] lg:-mx-[20px] -mb-[20px] bg-white",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: "secondary",
                            type: "submit",
                            title: "Spre plata",
                            disabled: !values.selectedOffer,
                            classesProp: "w-full sm:max-w-[250px]"
                        })
                    })
                ]
            });
        }
    }));
};
/* harmony default export */ var RcaOffers = ((0,es/* connect */.$j)(null, {
    addAlert: actions/* addAlert */.V_
})(RCAOferte));

;// CONCATENATED MODULE: ./containers/RCA/RCAForm.js







function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function RCAForm_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function RCAForm_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            RCAForm_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var FormComponentMap = {
    2: RCA_RCAProprietar,
    3: RCA_RCAVehicul,
    4: RCA_RCADataPolita,
    5: RcaOffers
};
var RCAForm = function(param) {
    var currentStep = param.currentStep, onStepChange = param.onStepChange, apiData = param.apiData, onApiDataUpdate = param.onApiDataUpdate, onLoadingStateChange = param.onLoadingStateChange, isFetching = param.isFetching;
    var ref = (0,react.useState)({
        startDate: null,
        vehicle: apiData.selectedVehicle && apiData.savedVehicles[apiData.selectedVehicle] ? apiData.savedVehicles[apiData.selectedVehicle] : {}
    }), formData = ref[0], setFormData = ref[1];
    var ref1 = (0,react.useState)([]), errors = ref1[0], setErrors = ref1[1];
    var handleFormDataUpdate = function(data) {
        setFormData(function(prev) {
            return RCAForm_objectSpread({}, prev, data);
        });
    };
    var handleErrorsUpdate = function(error) {
        setErrors(function(prevState) {
            return _toConsumableArray(prevState).concat(_toConsumableArray(error));
        });
    };
    var FormComponent = FormComponentMap[currentStep];
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative",
        children: errors.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: errors.map(function(error, index) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                    className: "space-y-[20px] bg-[white] p-[20px]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                        variant: error.variant,
                        message: error,
                        children: error.error
                    })
                }, index);
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FormComponent, {
            apiData: apiData,
            formData: formData,
            onFormDataUpdate: handleFormDataUpdate,
            onApiDataUpdate: onApiDataUpdate,
            onStepChange: onStepChange,
            onLoadingStateChange: onLoadingStateChange,
            isFetching: isFetching,
            onErrorsUpdate: handleErrorsUpdate
        })
    }));
};
/* harmony default export */ var RCA_RCAForm = (RCAForm);

// EXTERNAL MODULE: ./components/Loading.js
var Loading = __webpack_require__(24461);
// EXTERNAL MODULE: ./containers/Account/LoginForm.js
var LoginForm = __webpack_require__(77485);
;// CONCATENATED MODULE: ./containers/RCA/RCALogin.js




var RCALogin = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: "space-y-[20px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                as: "h4",
                display: "h2",
                title: "Intra in cont"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-sm text-gray-700 mb-6",
                children: "Pentru a continua, este necesar sa te autentifici in contul de client. Daca nu ai unul, iti poti crea unul rapid, mai jos."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                href: "/cont/intra",
                title: "Creeaza cont"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-white py-[20px] lg:py-[64px] px-[16px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "lg:max-w-[50%] mx-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginForm/* default */.Z, {})
                })
            })
        ]
    });
};
/* harmony default export */ var RCA_RCALogin = (RCALogin);

;// CONCATENATED MODULE: ./components/Icons/Rca/RcaNavCheckIcon.js

var RcaNavCheckIcon = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("svg", {
        fill: "currentColor",
        viewBox: "0 0 20 20",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M16.707 5.293a1 1 0 0 1 0 1.414l-8 8a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 1.414-1.414L8 12.586l7.293-7.293a1 1 0 0 1 1.414 0z"
        })
    });
};
/* harmony default export */ var Rca_RcaNavCheckIcon = (RcaNavCheckIcon);

;// CONCATENATED MODULE: ./containers/RCA/RCAStepNav.js



var RCA_NAV_STEPS = [
    {
        stepId: 1,
        label: "Informatii salvate"
    },
    {
        stepId: 2,
        label: "Proprietar"
    },
    {
        stepId: 3,
        label: "Vehicul"
    },
    {
        stepId: 4,
        label: "Data polita"
    },
    {
        stepId: 5,
        label: "Oferte"
    }, 
];
var RCAStepNav = function(param1) {
    var currentStep = param1.currentStep, onStepChange = param1.onStepChange, hasSavedVehicles = param1.hasSavedVehicles;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
        className: "overflow-x-auto pb-[16px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex items-center justify-center space-x-[28px] min-w-max",
            children: RCA_NAV_STEPS.map(function(param) {
                var stepId = param.stepId, label = param.label;
                var isActive = currentStep === stepId;
                var prevStep = stepId < currentStep;
                var shouldHideFirstStep = stepId === 1 && !hasSavedVehicles;
                if (shouldHideFirstStep) {
                    return null;
                }
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    type: "button",
                    onClick: function() {
                        return onStepChange(stepId);
                    },
                    disabled: !prevStep && !isActive,
                    className: classnames_default()("flex flex-col md:flex-row items-center flex-shrink-0 py-[4px] md:py-[8px] md:px-[16px] md:rounded-[4px] transition-all", {
                        "md:border md:border-black": isActive,
                        "md:bg-[#FAFAFA]": !isActive,
                        "cursor-pointer hover:bg-gray-100": prevStep,
                        "cursor-not-allowed": !prevStep && !isActive
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("w-5 h-5 rounded-full flex items-center justify-center mr-2 flex-shrink-0", {
                                "bg-primary border border-black": isActive || prevStep,
                                "bg-white border-2 border-[#808080]": !isActive && !prevStep
                            }),
                            children: prevStep && /*#__PURE__*/ (0,jsx_runtime.jsx)(Rca_RcaNavCheckIcon, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: classnames_default()("text-[12px] md:text-base font-medium whitespace-nowrap", {
                                "text-black font-medium": isActive || prevStep,
                                "text-[#808080]": !isActive && !prevStep
                            }),
                            children: label
                        })
                    ]
                }, stepId));
            })
        })
    });
};
/* harmony default export */ var RCA_RCAStepNav = (RCAStepNav);

;// CONCATENATED MODULE: ./containers/RCA/RCASidebar.js





function RCASidebar_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function RCASidebar_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                RCASidebar_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                RCASidebar_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var RCASidebarNew = function(param) {
    var cmsBlockData = param.cmsBlockData, onApiDataUpdate = param.onApiDataUpdate;
    (0,react.useEffect)(function() {
        var fetchCmsBlockData = function() {
            var _ref = RCASidebar_asyncToGenerator(runtime_default().mark(function _callee() {
                var ref, response1;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            _ctx.next = 3;
                            return (0,helpers/* makeApiCall */.Vo)({
                                apiCall: api/* getCmsBlocksApi */.xoW,
                                formatResponse: function(response) {
                                    return response.data;
                                },
                                apiArgs: [
                                    [
                                        "faq_asigurare-rca",
                                        "info_rca"
                                    ]
                                ]
                            });
                        case 3:
                            response1 = _ctx.sent;
                            if ((ref = response1.blocks) === null || ref === void 0 ? void 0 : ref.length) {
                                onApiDataUpdate({
                                    cmsBlockData: response1.blocks
                                });
                            }
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetchCmsBlockData() {
                return _ref.apply(this, arguments);
            };
        }();
        if (!(cmsBlockData === null || cmsBlockData === void 0 ? void 0 : cmsBlockData.length)) {
            fetchCmsBlockData();
        }
    }, []);
    if (!(cmsBlockData === null || cmsBlockData === void 0 ? void 0 : cmsBlockData.length)) {
        return null;
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "space-y-[20px]",
        children: cmsBlockData && cmsBlockData.map(function(block, index) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                className: "Cms",
                dangerouslySetInnerHTML: {
                    __html: block.content
                }
            }, "".concat(block.identifier, "-").concat(index));
        })
    }));
};
/* harmony default export */ var RCASidebar = (RCASidebarNew);

// EXTERNAL MODULE: ./components/Rca/LicensePlate.js + 1 modules
var LicensePlate = __webpack_require__(75860);
;// CONCATENATED MODULE: ./containers/RCA/RCASavedInfo/RCASavedInfoModal.js





var RCASavedInfoModal_ref = (0,config["default"])(), RCASavedInfoModal_publicRuntimeConfig = RCASavedInfoModal_ref.publicRuntimeConfig, websiteTitle = RCASavedInfoModal_publicRuntimeConfig.content.websiteTitle;
var ListItem = function(param) {
    var title = param.title, value = param.value;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
        className: "mb-2 last:mb-0 text-[14px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text-[#808080]",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "font-medium",
                children: value
            })
        ]
    });
};
var RCASavedInfoModal = function(param) {
    var isLoading = param.isLoading, vehicleDetails = param.vehicleDetails;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Modal["default"], {
        id: "".concat(vehicleDetails.id),
        header: "Detalii despre ".concat((vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.plateNo) || "autovehicul"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Alert/* default */.Z, {
                variant: "info",
                showIcon: true,
                children: [
                    "Daca doresti sa modifici aceste date, o poti face din contul tau",
                    " ",
                    websiteTitle,
                    ", sectiunea Asigurari RCA."
                ]
            }),
            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {
                height: 120
            }),
            !isLoading && !vehicleDetails && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-[40px] text-center",
                children: "Nu au fost gasite detalii pentru acest autovehicul."
            }),
            !isLoading && vehicleDetails && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col sm:flex-row gap-6 mt-[20px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "sm:w-[50%]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "font-semibold text-[18px] mb-3",
                                children: "Date autovehicul"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "space-y-2 text-sm",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                        title: "Numar de inmatriculare:",
                                        value: vehicleDetails.plateNo
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                        title: "Serie sasiu:",
                                        value: vehicleDetails.vin || "-"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                        title: "Marca si model:",
                                        value: vehicleDetails.commercialName || "-"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                        title: "Putere motor (kw):",
                                        value: vehicleDetails.enginePowerKw || "-"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "sm:w-[50%]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "font-semibold text-[18px] mb-3",
                                children: "Date proprietar"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "space-y-2 text-sm",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                        title: "Nume:",
                                        value: vehicleDetails.vehicleOwner.lastName || vehicleDetails.vehicleOwner.companyName || "-"
                                    }),
                                    vehicleDetails.vehicleOwner.legalType === "PF" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                        title: "Prenume:",
                                        value: vehicleDetails.vehicleOwner.firstName || "-"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                        title: vehicleDetails.vehicleOwner.legalType === "PF" ? "CNP:" : "CIF:",
                                        value: vehicleDetails.vehicleOwner.cif || "-"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var RCASavedInfo_RCASavedInfoModal = (RCASavedInfoModal);

// EXTERNAL MODULE: ./containers/ModalErrorBoundary.js
var ModalErrorBoundary = __webpack_require__(33849);
;// CONCATENATED MODULE: ./containers/RCA/RCASavedInfo/index.js











function RCASavedInfo_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function RCASavedInfo_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                RCASavedInfo_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                RCASavedInfo_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function RCASavedInfo_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function RCASavedInfo_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            RCASavedInfo_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var RCASavedInfo = function(param) {
    var addModal1 = param.addModal, onStepChange = param.onStepChange, openedModal = param.openedModal, onApiDataUpdate = param.onApiDataUpdate, apiData = param.apiData, onLoadingStateChange = param.onLoadingStateChange, isLoading = param.isLoading;
    var fetchVehicleDetails = function() {
        var _ref = RCASavedInfo_asyncToGenerator(runtime_default().mark(function _callee(vehicleId) {
            var response1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,helpers/* makeApiCall */.Vo)({
                            apiCall: api/* getRcaVehicleDetailsbyIdApi */.q5t,
                            apiArgs: [
                                vehicleId
                            ],
                            formatResponse: function(response) {
                                return response.data.data;
                            }
                        });
                    case 2:
                        response1 = _ctx.sent;
                        if (response1) {
                            onApiDataUpdate({
                                savedVehicles: RCASavedInfo_objectSpread({}, apiData.savedVehicles, RCASavedInfo_defineProperty({}, vehicleId, RCASavedInfo_objectSpread({}, response1, {
                                    fullDetailsFetched: true
                                })))
                            });
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchVehicleDetails(vehicleId) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleOpenModal = function() {
        var _ref = RCASavedInfo_asyncToGenerator(runtime_default().mark(function _callee(vehicleId) {
            var ref, ref1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        addModal1("".concat(vehicleId));
                        if ((ref = apiData.savedVehicles) === null || ref === void 0 ? void 0 : (ref1 = ref[vehicleId]) === null || ref1 === void 0 ? void 0 : ref1.fullDetailsFetched) {
                            _ctx.next = 7;
                            break;
                        }
                        if (!isLoading) {
                            onLoadingStateChange(true);
                        }
                        _ctx.next = 6;
                        return fetchVehicleDetails(vehicleId);
                    case 6:
                        onLoadingStateChange(false);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleOpenModal(vehicleId) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleNextStep = function() {
        var _ref = RCASavedInfo_asyncToGenerator(runtime_default().mark(function _callee(vehicleId) {
            var ref, ref2;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if ((ref = apiData.savedVehicles) === null || ref === void 0 ? void 0 : (ref2 = ref[vehicleId]) === null || ref2 === void 0 ? void 0 : ref2.fullDetailsFetched) {
                            _ctx.next = 6;
                            break;
                        }
                        if (!isLoading) {
                            onLoadingStateChange(true);
                        }
                        _ctx.next = 5;
                        return fetchVehicleDetails(vehicleId);
                    case 5:
                        onLoadingStateChange(false);
                    case 6:
                        onApiDataUpdate({
                            selectedVehicle: vehicleId
                        });
                        onStepChange(2);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleNextStep(vehicleId) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleNewPolicyData = function() {
        onApiDataUpdate({
            selectedVehicle: null
        });
        onStepChange(2);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "space-y-[20px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                as: "h4",
                title: "Date pentru polita",
                display: "h2",
                sameSizeOnMobile: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-sm font-medium",
                children: "Alege dintre datele deja salvate sau adauga date noi."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                type: "button",
                title: "Adauga date noi",
                onClick: function() {
                    return handleNewPolicyData();
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "space-y-4",
                children: Object.values(apiData.savedVehicles).map(function(vehicle) {
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                        className: "bg-white p-[16px] flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-[28px] sm:space-y-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "space-y-[10px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LicensePlate/* default */.Z, {
                                        plateNumber: vehicle.plateNo
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "font-medium",
                                        children: vehicle.vehicleName || "".concat(vehicle.brand || "", " ").concat(vehicle.model || "")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col sm:flex-row sm:items-center text-center gap-[20px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        type: "button",
                                        onClick: function() {
                                            return handleNextStep(vehicle.id);
                                        },
                                        title: "Foloseste"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "button",
                                        onClick: function() {
                                            return handleOpenModal(vehicle.id);
                                        },
                                        className: "w-full sm:w-auto text-red-brand hover:text-bleu-hover underline text-center sm:text-left",
                                        children: "Vezi detalii"
                                    })
                                ]
                            }),
                            openedModal === "".concat(vehicle.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalErrorBoundary/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RCASavedInfo_RCASavedInfoModal, {
                                    isLoading: isLoading,
                                    vehicleDetails: (ref = apiData.savedVehicles) === null || ref === void 0 ? void 0 : ref[vehicle.id]
                                })
                            })
                        ]
                    }, vehicle.id);
                })
            })
        ]
    }));
};
/* harmony default export */ var RCA_RCASavedInfo = ((0,es/* connect */.$j)(function(state) {
    return {
        openedModal: state.app.modal
    };
}, {
    addModal: actions/* addModal */.Y_
})(RCASavedInfo));

// EXTERNAL MODULE: ./containers/ErrorPage.js
var ErrorPage = __webpack_require__(75720);
;// CONCATENATED MODULE: ./pages/asigurari-rca/index.js

















function asigurari_rca_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function asigurari_rca_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asigurari_rca_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asigurari_rca_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function asigurari_rca_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function asigurari_rca_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            asigurari_rca_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var asigurari_rca_ref = (0,config["default"])(), asigurari_rca_publicRuntimeConfig = asigurari_rca_ref.publicRuntimeConfig, asigurari_rca_websiteName = asigurari_rca_publicRuntimeConfig.settings.websiteName;
var RcaPage = function(param) {
    var user = param.user, addAlert1 = param.addAlert, cmsBlockData = param.cmsBlockData;
    var ref3 = (0,react.useState)(1), currentStep = ref3[0], setCurrentStep = ref3[1];
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react.useState)({
        cmsBlockData: cmsBlockData
    }), apiData = ref2[0], setApiData = ref2[1];
    var isInitial = user.isInitial, isLoggedIn = user.isLoggedIn;
    var hasSavedVehicles = apiData.savedVehicles && Object.keys(apiData.savedVehicles).length > 0;
    var handleStepChange = function(step) {
        setCurrentStep(step);
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    var handleApiDataUpdate = function(data) {
        setApiData(function(prev) {
            return asigurari_rca_objectSpread({}, prev, data);
        });
    };
    var handleLoadingStateChange = function(loadingState) {
        setIsLoading(loadingState);
    };
    (0,react.useEffect)(function() {
        var fetchSavedVehicles = function() {
            var _ref = asigurari_rca_asyncToGenerator(runtime_default().mark(function _callee() {
                var ref4, response1, savedVehicles;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            if (!isLoading) {
                                setIsLoading(true);
                            }
                            _ctx.next = 4;
                            return (0,helpers/* makeApiCall */.Vo)({
                                apiCall: api/* getCustomerVehiclesApi */._gB,
                                returnResponse: true,
                                formatResponse: function(response) {
                                    return response.data.data;
                                },
                                preFail: function() {
                                    return addAlert1({
                                        message: "Eroare la \xeencărcarea vehiculelor salvate.",
                                        variant: "error"
                                    });
                                }
                            });
                        case 4:
                            response1 = _ctx.sent;
                            if (response1 === null || response1 === void 0 ? void 0 : (ref4 = response1.items) === null || ref4 === void 0 ? void 0 : ref4.length) {
                                savedVehicles = Object.fromEntries(response1.items.map(function(item) {
                                    return [
                                        item.id,
                                        item
                                    ];
                                }));
                                handleApiDataUpdate({
                                    savedVehicles: savedVehicles
                                });
                            } else {
                                setCurrentStep(2);
                            }
                            setIsLoading(false);
                        case 7:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetchSavedVehicles() {
                return _ref.apply(this, arguments);
            };
        }();
        if (isLoggedIn && !apiData.savedVehicles) {
            fetchSavedVehicles();
        }
    }, [
        isLoggedIn
    ]);
    if (asigurari_rca_websiteName === "bricostore" || asigurari_rca_websiteName === "mediagalaxy") {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* default */.Z, {
            layout: "404"
        }));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(head["default"], {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Asigurare RCA"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Asigurare RCA online - completeaza formularul si obtine oferta instantaneu"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                breadcrumbs: [
                    {
                        id: 1,
                        level: 99,
                        name: "RCA",
                        url: "/asigurari-rca"
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "py-[24px]",
                children: [
                    isLoggedIn && /*#__PURE__*/ (0,jsx_runtime.jsx)(RCA_RCAStepNav, {
                        currentStep: currentStep,
                        onStepChange: handleStepChange,
                        hasSavedVehicles: hasSavedVehicles
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col lg:flex-row lg:items-start gap-[26px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "bg-[#F5FBF4] mt-[36px] py-[20px] px-[15px] lg:px-[20px] max-h-fit rounded-tr-[4px] rounded-bl-[4px] lg:w-[60%] relative min-h-[200px]",
                                children: [
                                    !isLoggedIn && !isInitial && /*#__PURE__*/ (0,jsx_runtime.jsx)(RCA_RCALogin, {}),
                                    isLoggedIn && currentStep === 1 && hasSavedVehicles && /*#__PURE__*/ (0,jsx_runtime.jsx)(RCA_RCASavedInfo, {
                                        onStepChange: handleStepChange,
                                        onApiDataUpdate: handleApiDataUpdate,
                                        apiData: apiData,
                                        onLoadingStateChange: handleLoadingStateChange,
                                        isLoading: isLoading
                                    }),
                                    isLoggedIn && currentStep > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(RCA_RCAForm, {
                                        currentStep: currentStep,
                                        apiData: apiData,
                                        onApiDataUpdate: handleApiDataUpdate,
                                        onStepChange: handleStepChange,
                                        isFetching: isLoading,
                                        onLoadingStateChange: handleLoadingStateChange
                                    }),
                                    isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute flex items-center justify-center inset-0 bg-white overflow-hidden opacity-50 resetLoading min-h-[200px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {
                                            height: 100,
                                            hasMarginBottom: false
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "lg:w-[40%]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RCASidebar, {
                                    cmsBlockData: apiData.cmsBlockData,
                                    onApiDataUpdate: handleApiDataUpdate
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
RcaPage.pageLayout = "default";
RcaPage.getInitialProps = asigurari_rca_asyncToGenerator(runtime_default().mark(function _callee() {
    var ref5, response2;
    return runtime_default().wrap(function _callee$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                ;
                _ctx.next = 3;
                return (0,helpers/* makeApiCall */.Vo)({
                    apiCall: api/* getCmsBlocksApi */.xoW,
                    formatResponse: function(response) {
                        return response.data;
                    },
                    apiArgs: [
                        [
                            "faq_asigurare-rca",
                            "info_rca"
                        ]
                    ]
                });
            case 3:
                response2 = _ctx.sent;
                if (!(response2 === null || response2 === void 0 ? void 0 : (ref5 = response2.blocks) === null || ref5 === void 0 ? void 0 : ref5.length)) {
                    _ctx.next = 6;
                    break;
                }
                return _ctx.abrupt("return", {
                    cmsBlockData: response2.blocks
                });
            case 6:
            case "end":
                return _ctx.stop();
        }
    }, _callee);
}));
/* harmony default export */ var asigurari_rca = ((0,es/* connect */.$j)(function(state) {
    return {
        user: state.user
    };
}, {
    addAlert: actions/* addAlert */.V_
})(RcaPage));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8208,5337,3043,5891,9198,9585,9774,2888,179], function() { return __webpack_exec__(79459); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);